export const ruTranslations = {
  "common.show_list": "Показать меню сервисов",
  "common.hide_list": "Скрыть меню сервисов",
  "copy.email": "E-mail успешно скопирован",
  "table.paymentType": "Способ оплаты",
  "common.bad_code": "Неверный код",
  "tabs.all_items": "Все номера",
  "tabs.favorites": "Избранное",
  "captcha.notice": "Необходима верификация CAPTCHA",
  "CAPTCHA verification failed": "Проверка CAPTCHA не удалась",
  "common.payment_with": "Пополнение с помощью",
  "copy.address": "Адрес успешно скопирован",
  "wallet.create": "Создать кошелек",
  "wallet.wallet": "Кошелек",
  "wallet.min_amount": "Минимальная сумма",
  "wallet_com.commission_payment": "Комиссия за пополнение",
  "wallet_com.commission_network": "Комиссия сети",
  "wallet.error_title": "Важно!",
  "wallet.error_text":
    "Если сумма пополнения будет ниже минимально установленной, деньги не будут зачислены на баланс.",
  "wallet.warning_title": "Выбранная сеть и сеть перевода должны совпадать!",
  "wallet.warning_text":
    "В противном случае внесенные средства не будут зачислены на ваш баланс.",
  "common.no_numbers": "Нет доступных номеров для данного севриса",
  "common.hide_menu": "Скрыть меню",
  "common.go_to_panel": "Выйти из админ панели",
  "Invalid credentials.": "Неверные данные",
  "sorting.without": "Без сортировки",
  "header.language": "Выбора языка:",
  "sorting.date.minus": "По дате: сначала новые",
  "sorting.date.plus": "По дате: сначала старые",
  "sorting.status.plus": "По статусу: исходный порядок",
  "sorting.status.minus": "По статусу: обратный порядок",
  "common.username_forgot": "Введите E-mail для восстановления пароля",
  "common.coupon_amount": "Номер купона",
  "sorting.user.plus": "По пользователям: исходный порядок",
  "sorting.user.minus": "По пользователям: обратный порядок",
  "table.failed": "Неуспешно",
  "common.go_to_settings": "Перейти в настройки",
  "common.side_show_menu": "Показать/скрыть меню",
  "common.return_to_shop": "Вернуться в магазин",
  "table.failed_refunded": "Таймаут",
  "common.six_symbols_code": "Введите 6 значный код",
  notes: "Записи с",
  to: "по",
  of: "из",
  commission: "Комиссия",
  copyright: "SMS-ONLINE.PRO © Все права защищены",
  "about.plus1.title": "Моментальная выдача",
  "about.plus1.subtitle":
    "Вы получаете мгновенно выделенный номер для вашего сервиса",
  "about.plus2.title": "Получайте смс с любого сервиса",
  "about.plus2.subtitle":
    "Более 200 различных сайтов, с которых мы сможем принять СМС",
  "about.plus3.title": "Оплата за результат",
  "copy.phone": "Телефон успешно скопирован",
  "heading.auth": "Авторизация",
  "common.add": "Добавить",
  "common.payment_amount": "Сумма пополнения",
  "common.to_buy": "Перейти к оплате",
  "heading.have_account": "Уже есть аккаунт? Войдите!",
  "heading.auth_action": "Авторизоваться",
  "common.old_password": "Старый пароль",
  "common.choose_crypto": "Выбрать криптовалюту",
  "common.numbers_after_code": "Цифры после кода",
  "nav.menu.rule": "Правила",
  "preloader.text": "Пожалуйста подождите, загружаем контент",
  "prefix.list": "Список исключений",
  "common.us": "Написать нам",
  "common.turn_off": "Отключить",
  "common.tg": "Telegram канал",
  "common.history": "История",
  "common.auth_for": "Авторизуйтесь, для покупки номеров",
  "common.new_password": "Новый пароль",
  "common.confirm_password": "Повторите новый пароль",
  "common.change_password": "Изменить пароль",
  "common.email_password": "E-mail и пароль",
  "common.choose_price": "Выбрать цену",
  "common.off": "Выключена",
  "common.on": "Включена",
  "common.type.your_code": "Введите ваш код",
  "2fa.get": "Получить QR",
  "table.interval": "Интервал обновления",
  "table.5000": "5 сек.",
  "table.10000": "10 сек.",
  "table.15000": "15 сек.",
  "table.20000": "20 сек.",
  "status.order_complete": "Спасибо за регистрацию. Ваш код подтверждения",
  "about.plus3.subtitle":
    "Вы оплачиваете только те номера, на которые приходит СМС",
  money_rate: "Обменный курс",
  "sort.by": "Сортировать по",
  CountriesTop: "Топ страны",
  "register.alert":
    "Внимание! Мы не сможем восстановить доступ к вашему аккаунту, или сделать возврат средств, если вы будете использовать временную или одноразовую почту.",
  "2fa.notify_about_qr_off": `Чтобы выключить двухфакторную авторизацию нажмите кнопку “Отключить”`,
  "table.refill": "Пополнение",
  "table.waiting_phone": "Ожидаем звонка",
  "table.waiting_sms": "Ожидаем сообщение",
  "table.notFound": "Здесь еще ничего нет",
  "heading.balance_correction": "Корректировка баланса",
  "commission.0xprocessing": "Криптовалюта",
  "commission.coupon": "Купоны",
  "commission.manual": "Ручное пополнение",
  "commission.success": "Комиссия успешно изменена",
  "prefix.heading": "Исключение префиксов для виртуальных номеров",
  "table.amount_with_commission": "Сумма с комиссиией",
  "commission.lava": "Lava",
  "prefix.subheading":
    "Чтобы исключить из выдачи ненужные виртуальные номера, вы можете указать их по выбранной стране в блоке ниже. Исключенные префиксы будут применяться по умолчанию в запросе getNumber к API для указанной страны, если параметр phoneException не указан или не переопределен.",
  "prefix.delete": "Исключение успешно удалено",
  "prefix.add": "Добавить исключение",
  "prefix.edit": "Редактирование исключения",
  "prefix.edited": "Исключение успешно изменено",
  "prefix.added": "Исключение успешно добавлено",
  "The limit 15 of phones prefix has been reached by user":
    "Пользователь достиг предела в 15 префиксов телефонов.",
  "Phone prefix ignore should be unique":
    "Префикс телефона должен быть уникальным.",
  "The length of phones prefix is invalid":
    "Минимальная длина каждого префикса с учётом кода страны 4 символа",
  "button.save": "Сохранить",
  "nav.contacts": "Контакты",
  "cookie.heading": "Мы используем файлы cookie",
  "cookie.subheading":
    'Это безопасно. Файлы cookie хранятся только на вашем устройстве. Если вы не против, нажмите "Принять все файлы" или продолжите просмотр сайта.',
  "cookie.submit": "Принять все файлы",
  "auth.notice": "Я прочитал и принимаю",
  "auth.agree": "Пользовательское соглашение.",
  "fab.telegram": "Telegram",
  "fab.mail": "Электронная почта",
  "fab.support": "Техническая поддержка",
  "services.itemsCount": "шт",
  "services.from": "от",
  "search.services": "Введите название сервиса...",
  "search.country": "Найти страну",
  "This value is already used.": "Такой аккаунт уже зарегистрирован",
  "Password have forbidden symbols": "Пароль содержит запрещенные символы",
  "This value should be between 1 and 100.":
    "Значение должно находиться в диапазоне от 1 до 100",
  "This value should be of type numeric.": "Значение должно иметь числовой тип",
  "This value is not a valid email address.":
    "Значение не является адресом электронной почты",
  "Can't cancel order in first two minutes":
    "Невозможно отменить заказ в течение первых двух минут",
  "Insufficient balance": "Недостаточный баланс",
  "menu.coupons": "Купоны",
  "This value should be greater than or equal to dateFrom.":
    "Это значение должно быть больше или равно значению «дата с».",
  "table.new": "Новый",
  "table.activated": "Активирован",
  "date.invalid": "Некорректная дата",
  "Activation of coupons has been block by admin":
    "Активация купонов заблокирована администратором",
  "Activation of coupons has been temporary block":
    "Активация купонов временно заблокирована",
  "table.expired": "Истек",
  "table.not_number": "Нет номера",
  "heading.partners_products": "Партнерские продукты",
  "payout.success": "Средства успешно выведены",
  "table.choose_all": "Выбрать все",
  "table.deselect_all": "Снять выделение",
  "table.percent": "Введите процент",
  "placeholder.isPartner": "Партнер",
  "heading.partners": "Партнеры",
  "table.deleted": "Удален",
  "table.date_delete": "Дата удаления",
  "table.date_create": "Дата создания",
  "phone.not_found": "Телефонов не найдено",
  "table.delete": "Удалить",
  "table.coupons_is_delete": "Купоны успешно удалены",
  "table.coupon": "Купон",
  "toast.coupon": "Купон успешно применен",
  "table.adminId": "ID админа",
  "tabs.coupon": "Купоном",
  "tabs.crypto": "Криптовалютой",
  "table.provider": "Провайдер",
  "placeholder.isActivateCouponRestricted": "Активация купонов ограничена",
  "heading.partner": "Партнер",
  "placeholder.hash": "Код партнера",
  "pagination.show_all": "Показать все",
  "pagination.hide_all": "Скрыть все",
  "table.per_page_all": "На странице: Все",
  "heading.payout": "Вывести средства",
  coupon: "Купон",
  "order.repeatOrderTitle": "Повторная СМС будет стоить ",
  "order.repeatOrderSubtitle": "Запросить СМС?",
  "order.repeat_error": "Повторное СМС не отправлено",
  "order.repeat_success": "Повторное СМС отправлено",
  "order.cantRepeatSms": "Невозможно повторить отправку СМС",
  "table.buy": "Купить",
  "table.userId": "Пользователь",
  "table.user": "Пользователь",
  "toast.coupons": "Купоны успешно созданы",
  "placeholder.isActivated": "Активирован",
  "Coupon can not be activated": "Купон не может быть активирован",
  "Coupon not found": "Купон не найден",
  filters: "Фильтры",
  "heading.transactions": "Операции",
  "table.action": "Действие",
  "table.description": "Описание",
  "table.state": "Состояние операции",
  "table.order": "Заказ",
  "placeholder.registeredAt": "Дата регистрации",
  "placeholder.lastLoginAt": "Дата последнего входа",
  "placeholder.lastIp": "Последний IP",
  "placeholder.currency": "Валюта",
  "placeholder.balance": "Баланс",
  "placeholder.isAdmin": "Права администратора",
  "placeholder.isSupport": "Права саппорта",
  "heading.user": "Пользователь",
  "register.resend": "Повторно отправить ссылку",
  "resend.true": "На введеный Email отправлено письмо",
  "resend.false": "Количество попыток отправки письма исчерпано",
  "menu.admin_settings": "Настройки",
  "settings.is_creating_order_robust": "Прием заказов включен",
  "notification.order.creation_forbidden": "Создание заказов запрещено",
  "notification.order.creation_forbidden_by_system":
    "Создание заказов запрещено системой",
  "theme.light": "Светлая",
  "theme.dark": "Темная",
  "sorting.for": "Сортировать по:",
  "sorting.date": "Дате",
  "sorting.status": "Статусу",
  "sorting.user": "Пользователям",
  "heading.orders": "Заказы",
  "heading.users": "Пользователи",
  "stats.users": "Всего пользователей",
  "stats.admins": "Из них администраторов",
  "filter.search": "Поиск",
  "heading.active_orders": "Текущие заказы",
  "heading.finished_orders": "Завершенные заказы",
  "heading.interval": "Интервал обновления заказов (в секундах)",
  "menu.stats": "Статистика",
  "common.change": "Изменить",
  "common.password_forgot": "Восстановление пароля",
  "common.forgot": "Забыл пароль",
  "common.write_mail": "Введите E-mail для восстановления пароля",
  "common.forgot_info":
    "На почту отправлена инструкция для восстановления пароля",
  "common.update_password": "Введите новый пароль",
  "common.password_updated": "Пароль успешно обновлен",
  "common.restore": "Восстановить пароль",
  "balance.empty": "Сумма пополнения не может быть пустой",
  "balance.min": "Сумма пополнения не меньше 1$",
  "balance.max": "Сумма больше максимальной суммы",
  "password.length": "Пароль должен иметь более 10 символов",
  "password.register": "Пароль должен иметь буквы верхнего и нижнего регистра",
  "password.numbers": "Пароль должен содержать цифры",
  "password.symbols": "Пароль должен содержать специальные символы",
  "password.valid": "Не соблюдены условия для ввода пароля",
  "password.generate": "Сгенерировать пароль",
  "password.is_generated": "Пароль сгенерирован и скопирован в буффер обмена",
  "password.included_symbols": "Допустимые символы: ",
  "password.excluded_symbols":
    "Пароль должен содержать только валидные символы",
  "register.notify":
    "Вам необходимо подтвердить ваш аккаунт по почте. \nПерейдите по ссылке из письма.\n\nВозможно оно упало в папку СПАМ",
  "register.login_notify": "Требуется подтверждение электронной почты",
  "register.email": "E-mail успешно подтвержден",
  "helmet.title": "Виртуальные номера для приема смс онлайн",
  "helmet.description":
    "Одноразовые номера для регистрации более чем на 600 сервисах",
  "common.username": "Имя пользователя",
  "common.email": "Email",
  "common.password": "Пароль",
  "common.registration": "Регистрация",
  "common.login": "Войти",
  "common.logout": "Выйти",
  "common.cancel": "Отмена",
  "common.id": "ID",

  "common.pu": "ПУ",
  "common.phone": "Телефон",
  "table.sms_content": "SMS",
  "table.email_confirmed": "Email подтвержден",
  "table.order_cancel": "Заказ отменен",
  "common.balance": "Баланс",
  "common.state": "Состояние",
  "common.action": "Действие",
  "common.submit": "Отправить",
  "common.submit_form": "Подтвердить",
  "common.yes": "Да",
  "common.no": "Нет",
  "common.generate_api": "Сгенерировать новый ключ",
  "heading.api": "API-ключ",
  "heading.api_notify":
    "Письмо для подтверждения отправлено на почту. Ссылка действительна 2 часа.",
  "heading.api_text":
    "Сгенерируйте API-ключ для взаимодействия с сайтом через протокол API",
  "api.new": "Новый API-ключ успешно создан",
  "api.copy": "Скопировать API-ключ",
  "api.modal_text":
    "Используйте его для взаимодействия с сайтом через протокол API",
  "api.modal_security":
    "По соображению безопасности этот API-ключ будет показан лишь один раз.",
  "api.modal_save": "Пожалуйста, сохраните его",
  "api.error_modal":
    "Вы уже запрашивали API-ключ по данному запросу, или срок действия истек",
  "2fa.enable": "Двухфакторная авторизация",
  "2fa.notify_about_qr":
    "Для включения необходимо подвердить авторизацию. Ниже введите код аутентификатора",
  "2fa.login": "Для авторизации введите код аутентификатора",
  "2fa.cancel": "Вы уверены, что хотите отменить двухфакторную авторизацию?",
  "2fa.stores": "Для сканирования QR кода скачайте приложение",
  "common.your_code": "Ваш код",
  "common.notifications.fetch_data_error": "Не удалось получить данные",
  "common.notifications.fetch_create_error": "Произошла ошибка при создании",
  "common.confirmation.delete_body": "Подтвердите действие удаления",
  "common.confirmation.delete_title": "Внимание!",
  "front_page.body.register": "Зарегистрироваться",
  "menu.sms": "Главная",
  "menu.pay": "Пополнить баланс",
  "balance.payment_success": "Оплата прошла успешно",
  "balance.payment_failed": "Произошла ошибка при оплате",
  "menu.history": "История баланса",
  "menu.settings": "Настройки аккаунта",

  "menu.apikey": "Ваш Api-ключ: ",
  "language.ru": "Русский",
  "language.en": "Английский",
  "language.gb": "Английский",
  "language.es": "Испанский",
  "language.cn": "Китайский",
  "panel.type": "Режим админа",
  "common.not_valid": "Не валиден",
  "menu.logs": "Логи",
  "ip.ip_heading": "Список пользователей по IP адресу",
  "ip.email_heading": "Активность пользователей",
  "ip.ip_heading2": "Список номеров телефонов по IP адресу",
  "ip.email_heading2": "Список номеров телефонов по электронной почте",
  "ip.phone_heading2": "Список номеров телефонов по телефону",
  "ip.phone_heading": "Список пользователей по телефону",
  "ip.ips": "IP адреса",
  "ip.emails": "Электронная почта",
  "ip.phone": "Телефон",
  "ip.ips_from": "IP адреса (начало интервала)",
  "ip.ips_to": "IP адреса (конец интервала)",
  "ip.get_data": "Получить данные",
  "ip.export_csv": "Скачать CSV",
  "ip.export_excel": "Скачать Excel",
  "ip.export_json": "Скачать JSON",
  "ip.email_error": "Укажите электронную почту",
  "ip.ip_error": "Укажите IP адрес",
  "ip.phone_error": "Укажите номер телефона",
  "ip.interval_error": "Неверно указан интервал",
  profile: "Профиль",
  "placeholder.email": "E-mail",
  "placeholder.url": "Url",
  "placeholder.username": "Имя",
  "placeholder.description": "Описание",
  "placeholder.is_enabled": "Активен",
  "modal.cancel": "Закрыть",
  "modal.create": "Создать",
  "form.update_data": "Обновить данные",
  "confirm.agree": "Подтвердите действие",
  "confirm.confirm": "Подтвердить",
  "confirm.cancel": "Отменить",
  "login.title": "Вход в систему",
  "login.subtitle": "Войдите в свой аккаунт",
  "placeholder.image": "Изображение",
  "nav.main": "Главная",
  "nav.about": "О нас",
  "nav.work": "Как это работает?",
  "nav.services": "Сервисы",
  "nav.faq": "FAQ",
  "nav.api": "API",
  "menu.apikey_copy": "API-key скопирован",
  "nav.news": "Новости",
  "nav.profile": "Кабинет",
  "nav.rules": "Правила проекта",
  "heading.tagline": "Ваш сервис для приема SMS онлайн",
  "heading.payments": "Оплаты",
  "heading.order": "Заказы",
  "heading.services": "Сервисы",
  "heading.subtitle":
    "SMS-online.pro — это полностью автоматизированный сервис для приема СМС онлайн. \nЭто означает, что вам не понадобится мобильный телефон для подтверждения действий, активации аккаунтов в популярных сервисах. \nВы пополняете номер счета и получаете текст сообщения СМС-сообщение на экране. \nНаш сайт смс-активации также предлагает вам арендовать личный виртуальный номер телефона. ",
  "heading.add_pay": "Пополнение баланса",
  "about.text":
    "Виртуальный телефонный номер онлайн — это возможность принимать сообщения независимо от того, в какой точке планеты вы находитесь. Главное — доступ в сеть.\nДля совершения всех необходимых действий в сети вам не понадобится настоящий мобильный телефон — сервис функционирует независимо от того, находитесь ли вы в зоне покрытия мобильной сети или нет.\nВсе, что от вас требуется — это пополнить счет своего виртуального номера. Вам не нужно специальное оборудование и sim-карта.",
  "about.subtitle": "Для чего нужен виртуальный телефон?",
  "about.list1":
    "Если вы совершаете регулярные рассылки, то вам просто необходимо иметь десятки телефонных номеров, чтобы сообщение гарантированно доходило до абонента.",
  "about.list2":
    "Подтверждайте регистрации в социальных сетях и прочих сервисах — теперь вам доступна регистрация множества аккаунтов на любых сайтах, которые можно использовать в своих целях.",
  "about.list3":
    "Вы можете использовать свой виртуальный номер в целях защиты от спама основного телефона при регистрации на подозрительных ресурсах",
  "about.subtext":
    "Основным преимуществом виртуального телефона можно считать его дешевизну. Получается, что у вас есть телефон, который вы можете использовать для разных целей — беспрепятственный полет вашей фантазии гарантирован.\n\nВаш личный телефонный номер онлайн — это гарантия того, что вы всегда будете на связи! Бывают ситуации, когда человек потерял телефон, забыл за него заплатить, случайно оставил дома, когда собирал вещи в поездку.\nВместе с нами — это больше не проблема! Все, что вам нужно — это доступ к сети интернет.",
  "work.subtitle":
    "Принимайте смс-сообщения на виртуальный номер с любых доступных сервисов",
  "work.text1": "Зарегистрируйте аккаунт в нашей системе",
  "work.text2": "Пополните баланс",
  "work.text3": "Получайте смс с любого сервиса",
  "services.subtitle": "Сервисы, с которых мы принимаем СМС на текущий момент",
  "table.service": "Сервис",
  "filters.date_two_week":
    "Максимально допустимый период запроса - 2 недели. Если необходим больший период - вы можете выгрузить данные в CSV файл",
  "table.date": "Дата",
  "filter.datepicker": "Выберите дату",
  "table.status": "Статус",
  "table.statuses": "Статус",
  "table.amount": "Сумма",
  "table.type": "Тип",
  "table.waiting": "Ожидается",
  "table.approved": "Подтверждено",
  "table.declined": "Отклонено",
  "table.canceled": "Отменено",
  "table.no_numbers": "Нет номеров",
  "table.finished": "Завершено",
  "table.new": "Новый",
  "table.balance_correction": "Коррекция баланса",
  "table.correction": "Коррекция баланса",
  "text.minCount": "Мин. сумма",
  "text.maxCount": "Макс. сумма",
  "text.alotof": "Много",
  "table.count": "Количество",
  "table.price": "Цена",
  "table.order_create": "Заказ успешно создан",
  "table.country": "Страна",

  "table.all": "Все",
  "table.few": "Мало",
  "table.not_found": "Не найдено",
  "table.per_page": "На странице",
  "table.dateFrom": "Дата с",
  "table.dateTo": "Дата до",
  "world.europe": "Европа",
  "world.asia": "Азия",
  "world.africa": "Африка",
  "world.south_america": "Южная Америка",
  "world.north_america": "Северная Америка",
  "world.oceania": "Океания",
  "world.choose": "Выбрать страну",

  "country.af": "Афганистан",
  "country.al": "Албания",
  "country.aq": "Антарктида",
  "country.dz": "Алжир",
  "country.as": "Восточное Самоа",
  "country.ad": "Андорра",
  "country.ao": "Ангола",
  "country.ag": "Антигуа и Барбуда",
  "country.az": "Азербайджан",
  "country.ar": "Аргентина",
  "country.au": "Австралия",
  "country.at": "Австрия",
  "country.bs": "Багамы",
  "country.bh": "Бахрейн",
  "country.bd": "Бангладеш",
  "country.am": "Армения",
  "country.bb": "Барбадос",
  "country.be": "Бельгия",
  "country.bm": "Бермуды",
  "country.bt": "Бутан",
  "country.bo": "Боливия",
  "country.ba": "Босния и Герцеговина",
  "country.bw": "Ботсвана",
  "country.bv": "Буве",
  "country.br": "Бразилия",
  "country.bz": "Белиз",
  "country.io": "Британ. Террит.",
  "country.sb": "Соломоновы О-ва",
  "country.vg": "Виргин. О-ва, Биртанские",
  "country.bn": "Бруней",
  "country.bg": "Болгария",
  "country.mm": "Мьянма",
  "country.bi": "Бурунди",
  "country.by": "Беларусь",
  "country.kh": "Камбоджа",
  "country.cm": "Камерун",
  "country.ca": "Канада",
  "country.cv": "Кабо-верде",
  "country.ky": "Кайман",
  "country.cf": "Центр. - Афр. Республика",
  "country.lk": "Шри-ланка",
  "country.td": "Чад",
  "country.cl": "Чили",
  "country.cn": "Китай",
  "country.tw": "Тайвань",
  "country.cx": "О-в Рождества",
  "country.cc": "Кокосовые О-ва",
  "country.co": "Колумбия",
  "country.km": "Коморы",
  "country.yt": "Майотта",
  "country.cg": "Конго",
  "country.cd": "Конго",
  "country.ck": "О-ва Кука",
  "country.cr": "Коста-рика",
  "country.hr": "Хорватия",
  "country.cu": "Куба",
  "country.cy": "Кипр",
  "country.cz": "Чехия",
  "country.bj": "Бенин",
  "country.dk": "Дания",
  "country.dm": "Доминика",
  "country.do": "Доминиканская Республика",
  "country.ec": "Эквадор",
  "country.sv": "Эль-сальвадор",
  "country.gq": "Экваториальная Гвинея",
  "country.et": "Эфиопия",
  "country.er": "Эритрея",
  "country.ee": "Эстония",
  "country.fo": "Фарерские О-ва",
  "country.fk": "Фолклендские О-ва",
  "country.gs": "Южная Джорджия и Южные Сандвичевы Острова",
  "country.fj": "Фиджи",
  "country.fi": "Финляндия",
  "country.ax": "Эландские Острова",
  "country.fr": "Франция",
  "country.gf": "Гвиана",
  "country.pf": "Французская Полинезия",
  "country.tf": "Фр. Южные Территории",
  "country.dj": "Джибути",
  "country.ga": "Габон",
  "country.ge": "Грузия",
  "country.gm": "Гамбия",
  "country.ps": "Палестинская Территория, Оккупированная",
  "country.de": "Германия",
  "country.gh": "Гана",
  "country.gi": "Гибралтар",
  "country.ki": "Кирибати",
  "country.gr": "Греция",
  "country.gl": "Гренландия",
  "country.gd": "Гренада",
  "country.gp": "Гваделупа",
  "country.gu": "Гуам",
  "country.gt": "Гватемала",
  "country.gn": "Гвинея",
  "country.gy": "Гайана",
  "country.ht": "Гаити",
  "country.hm": "Херд и Макдональд",
  "country.va": "Ватикан",
  "country.hn": "Гондурас",
  "country.hk": "Гонконг",
  "country.hu": "Венгрия",
  "country.is": "Исландия",
  "country.in": "Индия",
  "country.id": "Индонезия",
  "country.ir": "Иран",
  "country.iq": "Ирак",
  "country.ie": "Ирландия",
  "country.il": "Израиль",
  "country.it": "Италия",
  "country.ci": "Кот Д'ивуар",
  "country.jm": "Ямайка",
  "country.jp": "Япония",
  "country.kz": "Казахстан",
  "country.jo": "Иордания",
  "country.ke": "Кения",
  "country.kp": "Корея [КНДР)",
  "country.kr": "Корея",
  "country.kw": "Кувейт",
  "country.kg": "Кыргызстан",
  "country.la": "Лаос",
  "country.lb": "Ливан",
  "country.ls": "Лесото",
  "country.lv": "Латвия",
  "country.lr": "Либерия",
  "country.ly": "Ливия",
  "country.li": "Лихтенштейн",
  "country.lt": "Литва",
  "country.lu": "Люксембург",
  "country.mo": "Макао",
  "country.mg": "Мадагаскар",
  "country.mw": "Малави",
  "country.my": "Малайзия",
  "country.mv": "Мальдивы",
  "country.ml": "Мали",
  "country.mt": "Мальта",
  "country.mq": "Мартиника",
  "country.mr": "Мавритания",
  "country.mu": "Маврикий",
  "country.mx": "Мексика",
  "country.mc": "Монако",
  "country.mn": "Монголия",
  "country.md": "Молдова",
  "country.me": "Черногория",
  "country.ms": "Монтсеррат",
  "country.ma": "Марокко",
  "country.mz": "Мозамбик",
  "country.om": "Оман",
  "country.na": "Намибия",
  "country.nr": "Науру",
  "country.np": "Непал",
  "country.nl": "Нидерланды",
  "country.an": "Нидерландские Антилы",
  "country.aw": "Аруба",
  "country.nc": "Новая Каледония",
  "country.vu": "Вануату",
  "country.nz": "Новая Зеландия",
  "country.ni": "Никарагуа",
  "country.ne": "Нигер",
  "country.ng": "Нигерия",
  "country.nu": "Ниуэ",
  "country.nf": "Норфолк",
  "country.no": "Норвегия",
  "country.mp": "Марианские Острова",
  "country.um": "Малые Тихоок. Острова (США)",
  "country.fm": "Микронезия",
  "country.mh": "Маршалловы Острова",
  "country.pw": "Палау",
  "country.pk": "Пакистан",
  "country.pa": "Панама",
  "country.pg": "Папуа - Новая Гвинея",
  "country.py": "Парагвай",
  "country.pe": "Перу",
  "country.ph": "Филиппины",
  "country.pn": "Питкэрн",
  "country.pl": "Польша",
  "country.pt": "Португалия",
  "country.gw": "Гвинея-бисау",
  "country.tp": "Восточный Тимор",
  "country.pr": "Пуэрто-рико",
  "country.qa": "Катар",
  "country.re": "Реюньон",
  "country.ro": "Румыния",
  "country.ru": "Россия",
  "country.rw": "Руанда",
  "country.sh": "Святая Елена",
  "country.kn": "Сент-китс и Невис",
  "country.ai": "Ангилья",
  "country.lc": "Сент-люсия",
  "country.pm": "Сен-пьер и Микелон",
  "country.vc": "Сент-винсент и Гренадины",
  "country.sm": "Сан-марино",
  "country.st": "Сан-томе и Принсипи",
  "country.sa": "Саудовская Аравия",
  "country.sn": "Сенегал",
  "country.rs": "Сербия",
  "country.sc": "Сейшелы",
  "country.sl": "Сьерра-леоне",
  "country.sg": "Сингапур",
  "country.sk": "Словакия",
  "country.vn": "Вьетнам",
  "country.si": "Словения",
  "country.so": "Сомали",
  "country.za": "Южная Африка",
  "country.zw": "Зимбабве",
  "country.es": "Испания",
  "country.eh": "Западная Сахара",
  "country.sd": "Судан",
  "country.sr": "Суринам",
  "country.tr": "Турция",
  "country.xy": "Случайная страна",
  "country.ua": "Украина",
  "country.gb": "Великобритания",
  "country.se": "Швеция",
  "country.ch": "Швейцария",
  "country.mk": "Македония",
  "country.ae": "ОАЭ",
  "country.gg": "Гернси",
  "country.je": "Джерси",
  "country.im": "о-в Мэн",
  "country.sj": "Шпицберген и Ян-Майен",
  "country.tm": "Туркменистан",
  "country.uz": "Узбекистан",
  "country.ye": "Йемен",
  "country.tl": "Восточный Тимор",
  "country.tj": "Таджикистан",
  "country.th": "Тайланд",
  "country.sy": "Сирия",
  "country.tn": "Тунис",
  "country.tg": "Того",
  "country.ug": "Уганда",
  "country.tz": "Танзания",
  "country.bf": "Буркина-Фасо",
  "country.zm": "Замбия",
  "country.sz": "Эсватини",
  "country.tc": "Острова Теркс и Кайкос",
  "country.tt": "Тринидад и Тобаго",
  "country.uy": "Уругвай",
  "country.vi": "Американские Виргинские острова",
  "country.ve": "Венесуэла",
  "country.tk": "Токелау",
  "country.us": "США",
  "country.to": "Тонга",
  "country.tv": "Тувалу",
  "country.wf": "о-ва Уоллис и Футуна",
  "country.ws": "Самоа",
  "country.eg": "Египет",
  "country.search": "Поиск по странам",
  "rules.content":
    "<h2>Пользовательское соглашение</h2><div>1. Порядок проведения активации следующий:\n• 1.1. в левом меню выбрать нужную социальную сеть или мессенджер и нажать 'Купить'\n• 1.2 использовать выделенный номер, убедится что смс на него выслано и нажать зеленую кнопку 'Готов'\n• 1.3 дождаться поступления смс и отображения его содержания напротив соответствующего номера\n• 1.4 если Вам необходимо получить больше одной смс, следует выбрать 'повторить' и после этого отправить еще одно сообщение с данного сервиса. (На некоторых номерах телефонах эта функция может отсутствовать, сервис не гарантирует данной опции или за нее может взыматься доп. плата).\n• 1.5 если все верно, и Вы хотите закончить работу с данным сервисом необходимо нажать кнопку 'Завершить', либо активация успешно завершается автоматически по истечении времени (15 минут)\n• 1.6 максимальное время ожидания поступления смс составляет 20 минут, после чего выделение номера завершается.\n2. Стоимость активаций списывается согласно прейскуранту (отображается в меню на странице пользователя).\n• 2.1. Деньги списываются с баланса по завершению операции (п.1.4,1.5 регламента).\n3. Если номер выделен, но не использован (то есть Вы не увидели код из смс), Вы можете в любой момент отменить операцию без какого-либо штрафа. В случае злоупотребления будут применены санкции на усмотрение модератора.\n4. При регистрации на сайте Вы даёте согласие на получение рекламных материалов от SMS-online. От рассылки Вы можете отписаться в любой момент\n5. История операций с номерами хранится в вашем аккаунте и доступна в верхнем меню 'История'. История активаций хранится бессрочно и не подлежит удалению\n6. Запрещено использование SMS-online в любых противоправных целях.\n• 6.1 Запрещено использование сервиса для осуществления платных подписок.\n7. Мы не несем ответственности за созданные аккаунты, все действия, включая возможные блокировки, осуществляются исключительно на страх и риск конечного пользователя, который приобрел активацию\n• 7.1. Запрещено проведение активаций в Qiwi и Webmoney\n• 7.2 Запрещено проведение активаций в банковском секторе.\n8. Возврат денежных средств предусмотрен только при подаче заявки на <a href='mailto:support@sms-online.pro'>support@sms-online.pro</a> с той почты на которую произведена регистрация. Также информируем Вас о том, что при запросе возврата денежных средств при отказе от покупки, возврат производится исключительно на ту же банковскую карту и в той же валюте, которой была произведена оплата.\n9. Гарантия на номера с переадресацией составляет 2 недели. В случае, если номер перестал работать по не зависящим от клиента причинам, деньги будут возвращены.\n10. Мы не несем ответственности за некорректное программирование API-интерфейса, или за иные программные ошибки, которые допускает пользователь неправильно трактуя описанный API-протокол. Возврат денежных средств за программные ошибки пользователей - не предусмотрен\n11. Прием смс от платежной системы Qiwi - не предусмотрен\n12. При оплате заказа банковской картой, обработка платежа (включая ввод номера карты) происходит на защищенной странице процессинговой системы, которая прошла международную сертификацию. Это значит, что Ваши конфиденциальные данные (реквизиты карты, регистрационные данные и др.) не поступают в интернет-магазин, их обработка полностью защищена и никто, в том числе наш сервис, не может получить персональные и банковские данные клиента. При работе с карточными данными применяется стандарт защиты информации, разработанный международными платёжными системами Visa и Masterсard-Payment Card Industry Data Security Standard (PCI DSS), что обеспечивает безопасную обработку реквизитов Банковской карты Держателя. Применяемая технология передачи данных гарантирует безопасность по сделкам с Банковскими картами путем использования протоколов Secure Sockets Layer (SSL), Verified by Visa, Secure Code,и закрытых банковских сетей, имеющих высшую степень защиты.\n13. Использование ошибок или брешей в системе безопасности запрещено и будет рассматриваться органами правопорядка.\n14. Аккаунт SMS- online идентифицируется исключительно той почтой, которую Вы указали при регистрации.\n15. В целях безопасности, администрация в праве заморозить Ваш аккаунт в следующих случаях:\n15.1. Отсутствия активности 6 месяцев\n15.2 Выявления подозрительной/сторонней активности.\n16. Восстановление замороженного аккаунта возможно исключительно через почту, которую Вы указали при регистрации.</div>",
};

export const enTranslations = {
  "common.hide_menu": "Hide menu",
  "common.show_list": "Show service menu",
  "common.hide_list": "Hide service menu",
  "captcha.notice": "CAPTCHA verification required",
  "CAPTCHA verification failed": "CAPTCHA verification failed",
  "header.language": "Choose language:",
  "common.payment_with": "Top up with",
  "tabs.all_items": "All issues",
  "tabs.favorites": "Favorites",
  "copy.address": "Address successfully copied",
  "wallet.min_amount": "Minimum amount",
  "wallet_com.commission_payment": "Deposit fee",
  "wallet_com.commission_network": "Network fee",
  "wallet.create": "Create wallet",
  "wallet.wallet": "Wallet",
  "wallet.error_title": "Important!",
  "wallet.error_text":
    "If the top-up amount is lower than the minimum set, the money will not be credited to the balance.",
  "wallet.warning_title":
    "The selected network and the transfer network must match!",
  "wallet.warning_text":
    "Otherwise, the deposited funds will not be credited to your balance.",
  "common.go_to_panel": "Exit admin panel",
  "theme.light": "Light",
  "register.resend": "Resend link",
  "nav.contacts": "Contacts",
  "resend.true": "A letter has been sent to the entered Email",
  "commission.lava": "Lava",
  "copy.email": "Email successfully copied",
  "common.bad_code": "Invalid code",
  "common.no_numbers": "No available numbers for this service",
  "resend.false":
    "The number of attempts to send the letter has been exhausted",
  "prefix.heading": "Exclude prefixes for virtual numbers",
  "prefix.subheading":
    "To exclude unnecessary virtual numbers from being returned, you can specify them for the selected country in the block below. Excluded prefixes will be applied by default in the getNumber request to the API for the specified country if the phoneException parameter is not specified or overridden.",
  "prefix.delete": "Exception successfully deleted",
  "prefix.add": "Add exception",
  "prefix.edit": "Editing exception",
  "prefix.edited": "Exception edited successfully",
  "prefix.added": "Exception added successfully",
  "The limit 15 of phones prefix has been reached by user":
    "The user has reached the limit of 15 phone prefixes.",
  "The length of phones prefix is invalid":
    "The minimum length of each prefix, taking into account the country code, is 4 characters",
  "button.save": "Save",
  notes: "Entries",
  "sorting.user.plus": "By users: original order",
  "sorting.user.minus": "By users: reverse order",
  "table.failed": "Failed",
  "common.go_to_settings": "Go to settings",
  "common.side_show_menu": "Show/hide menu",
  "common.return_to_shop": "Return to shop",
  "table.failed_refunded": "Timeout",
  "common.six_symbols_code": "Enter 6-digit code",
  "sorting.without": "No sorting",
  "sorting.date.minus": "By date: newest first",
  "sorting.date.plus": "By date: oldest first",
  "sorting.status.plus": "By status: original order",
  "sorting.status.minus": "By status: reverse order",
  "common.username_forgot": "Enter email to recover password",
  "common.coupon_amount": "Coupon number",
  CountriesTop: "Countries TOP",
  "services.itemsCount": "pcs",
  "services.from": "from",
  "search.services": "Find a service",
  "search.country": "Find country",
  to: "to",
  "date.invalid": "Некорректная дата",
  of: "of",
  copyright: "SMS-ONLINE.PRO © All rights reserved",
  "about.plus1.title": "Instant issuance",
  "about.plus1.subtitle":
    "You instantly receive a dedicated number for your service",
  "about.plus2.title": "Receive SMS from any service",
  "about.plus2.subtitle":
    "More than 200 different sites from which we can receive SMS",
  "about.plus3.title": "Payment for the result",
  "copy.phone": "Phone successfully copied",
  "heading.auth": "Authorization",
  "common.add": "Add",
  "common.payment_amount": "Top-up amount",
  "common.to_buy": "Proceed to payment",
  "heading.have_account": "Already have an account? Log in!",
  "heading.auth_action": "Log in",
  "common.old_password": "Old password",
  "common.choose_crypto": "Choose cryptocurrency",
  "common.numbers_after_code": "Numbers after code",
  "nav.menu.rule": "Rules",
  "preloader.text": "Please wait, loading content",
  "prefix.list": "List of exceptions",
  "common.us": "Write to us",
  "common.turn_off": "Disable",
  "common.tg": "Telegram channel",
  "common.history": "History",
  "common.auth_for": "Log in to buy numbers",
  "common.new_password": "New password",
  "common.confirm_password": "Repeat new password",
  "common.change_password": "Change password",
  "common.email_password": "E-mail and password",
  "common.choose_price": "Choose price",
  "common.off": "Disabled",
  "common.on": "Enabled",
  "common.type.your_code": "Enter your code",
  "2fa.get": "Get QR",
  "table.interval": "Update interval",
  "table.5000": "5 sec.",
  "table.10000": "10 sec.",
  "table.15000": "15 sec.",
  "table.20000": "20 sec.",
  "status.order_complete": "Thank you for registering. Your confirmation code",
  "about.plus3.subtitle":
    "You pay only for the numbers to which the SMS is sent",
  money_rate: "Exchange rate",
  "sort.by": "Sort by",
  CountriesTop: "Top countries",
  "register.alert":
    "Attention! We will not be able to restore access to your account or make a refund if you use a temporary or disposable email.",
  "2fa.notify_about_qr_off": `To turn off two-factor authentication click the “Disable” button`,
  "table.refill": "Refill",
  "table.waiting_phone": "Waiting for a call",
  "table.waiting_sms": "Waiting for a message",
  "table.notFound": "There is nothing here yet",
  "order.repeatOrderTitle": "Repeat SMS will cost ",
  "order.repeatOrderSubtitle": "Request SMS?",
  "order.repeat_error": "Repeat SMS not sent",
  "order.repeat_success": "Repeat SMS sent",
  "order.cantRepeatSms": "Unable to repeat sending SMS",
  "heading.partners_products": "Partner Products",
  "table.choose_all": "Select all",
  "register.alert":
    "Attention! We will not be able to restore access to your account or issue a refund if you use temporary or disposable mail.",
  "table.deselect_all": "Deselect",
  "table.percent": "Enter percentage",
  "placeholder.isPartner": "Partner",
  "heading.partners": "Partners",
  "table.provider": "Provider",
  "table.adminId": "Admin ID",
  "table.deleted": "Deleted",
  "auth.notice": "I have read and accept",
  "auth.agree": "User Agreement.",
  "fab.telegram": "Telegram",
  "fab.mail": "Email",
  "fab.support": "Technical Support",
  "table.date_delete": "Delete date",
  "table.date_create": "Creation date",
  "table.delete": "Delete",
  "table.coupons_is_delete": "Coupons successfully deleted",
  "menu.coupons": "Coupons",
  "table.new": "New",
  "table.activated": "Activated",
  "table.expired": "Expired",
  "table.not_number": "No number",
  "table.coupon": "Coupon",
  "toast.coupon": "Coupon applied successfully",
  "tabs.coupon": "Coupon",
  "tabs.crypto": "Cryptocurrency",
  "table.buy": "Buy",
  "table.userId": "User",
  "table.user": "User",
  "toast.coupons": "Coupons successfully generated",
  "placeholder.isActivated": "Activated",
  "Coupon cannot be activated": "Coupon cannot be activated",
  "Coupon not found": "Coupon not found",
  "menu.admin_settings": "Settings",
  "notification.order.creation_forbidden": "Order creation forbidden",
  "notification.order.creation_forbidden_by_system":
    "Creating order is forbidden by system",
  "settings.is_creating_order_robust": "Order acceptance enabled",
  "table.not_number": "No number",
  "table.buy": "Buy",
  filters: "Filters",
  "theme.dark": "Dark",
  "sorting.for": "Sort by:",
  "sorting.date": "Date",
  "sorting.status": "Status",
  "sorting.user": "Users",
  commission: "Commission",
  "commission.0xprocessing": "Cryptocurrency",
  "commission.coupon": "Coupons",
  "commission.manual": "Manual commissioning",
  "commission.success": "Commission changed successfully",
  "table.order": "Order",
  "common.change": "Change",
  "heading.orders": "Orders",
  "heading.users": "Users",
  "filters.date_two_week":
    "The maximum allowable request period is 2 weeks. If a longer period is needed, you can upload the data to a CSV file",
  "stats.users": "Total users",
  "stats.admins": "Of which administrators",
  "heading.active_orders": "Current orders",
  "heading.balance_correction": "Balance correction",
  "phone.not_found": "No phones found",
  "heading.finished_orders": "Completed orders",
  "heading.interval": "Order update interval (in seconds)",
  "menu.stats": "Statistics",
  "common.password_forgot": "Password restore",
  "common.forgot": "Forgot your password?",
  "common.write_mail": "Enter your password recovery email",
  "common.forgot_info":
    "A password restoration rule has been sent to your email",
  "common.update_password": "Enter your new password",
  "common.password_updated": "Password updated successfully",
  "common.restore": "Restore password",
  "balance.empty": "The top-up amount cannot be empty",
  "balance.min": "Deposit amount is not less than 1$",
  "balance.max": "Amount greater than maximum amount",
  "helmet.title": "Virtual numbers for receiving SMS online",
  "helmet.description":
    "Disposable numbers for registration on more than 600 services",
  "password.length": "Password must be more than 10 characters",
  "password.register": "Password must have uppercase and lowercase letters",
  "password.numbers": "Password must contain numbers",
  "password.symbols": "Password must contain special symbols",
  "password.valid": "The conditions for entering the password were not met",
  "password.generate": "Generate password",
  "heading.transactions": "Transactions",
  "table.action": "Action",
  "table.description": "Description",
  "table.state": "Operation state",
  "placeholder.registeredAt": "Registered At",
  "placeholder.lastLoginAt": "Last login date",
  "placeholder.lastIp": "Last IP",
  "placeholder.currency": "Currency",
  "placeholder.balance": "Balance",
  "placeholder.isAdmin": "Admin rules",
  "placeholder.isSupport": "Support rules",
  "heading.user": "User",
  "password.is_generated":
    "Password has been generated and copied to the clipboard",
  "password.included_symbols": "Accepted symbols: ",
  "password.excluded_symbols": "The password must contain only valid symbols",
  "register.notify":
    "You need to confirm your account by mail.\nFollow the link from the letter.\n\nIt may have fallen into the SPAM folder",
  "register.login_notify": "Email confirmation required",
  "register.email": "Email successfully confirmed",
  "breadcrumb.devices": "Devices",
  "common.email": "Email",
  "table.amount_with_commission": "Amount minus commission",
  "breadcrumb.main": "main",
  "cookie.heading": "We use cookies",
  "cookie.subheading": `It's safe: cookies are only stored on your device. If you don't mind, click "Accept all cookies" or continue browsing the site.`,
  "cookie.submit": "Accept all cookies",
  "breadcrumb.operators": "operators",
  "breadcrumb.orders": "orders",
  "breadcrumb.partner": "partner",
  "breadcrumb.partners": "partners",
  "breadcrumb.payments": "payments",
  "breadcrumb.profiles": "profiles",
  "breadcrumb.services": "services",
  "breadcrumb.simcards": "sim cards",
  "breadcrumb.simfilters": "sim filters",
  "breadcrumb.transactions": "transactions",
  "common.added": "added",
  "common.cancel": "Cancel",
  "common.countries": "countries",
  "common.id": "ID",
  "common.county": "county",
  "common.forwardable": "forwardable",
  "common.iccid_prefix": "iccid prefix",
  "common.login": "Login",
  "common.registration": "Registration",
  "common.username": "Username",
  "common.password": "Password",
  "common.logout": "Log out",
  "common.type": "Type",
  "common.phone": "Phone",
  "table.sms_content": "SMS",
  "placeholder.isActivateCouponRestricted": "Coupon activation restricted",
  "table.email_confirmed": "Email confirmed",
  "table.few": "Few",
  "common.pu": "Partner control",
  "common.balance": "Balance",
  "common.operator": "operator",
  "common.operators": "operators",
  "common.register": "Register",
  "common.ussd_new_sim": "ussd new sim",
  "common.ussd_number": "ussd number",
  "common.submit": "Submit",
  "common.submit_form": "Submit",
  "common.yes": "Yes",
  "common.no": "No",
  "common.generate_api": "Generate new key",
  "heading.api": "API key",
  "heading.api_notify":
    "A confirmation email has been sent. The link is valid for 2 hours.",
  "heading.api_text":
    "Generate an API key to interact with the site via the API protocol",
  "api.new": "New API key created successfully",
  "api.copy": "Copy API key",
  "api.modal_text": "Use this to interact with the site via the API protocol",
  "api.modal_security":
    "For security reasons, this API key will only be shown once.",
  "api.modal_save": "Please save it",
  "api.error_modal":
    "You have already requested an API key for this request, or it has expired",
  "2fa.enable": "Two-factor authentication",
  "2fa.notify_about_qr":
    "Authentication must be confirmed to enable. Please enter the authenticator code below",
  "2fa.login": "Enter your authenticator code to login",
  "2fa.cancel": "Are you sure you want to cancel 2FA?",
  "2fa.stores": "Download the app to scan the QR code",
  "common.your_code": "Your Code",
  "devices.not_found": "Devices not found",
  "devices.show_all": "Show all devices",
  "partners.actions.add": "Add",

  "licenses.header.title": "Licenses",
  "licenses.limit.title": "Licenses limit",
  "licenses.edit_modal.title": "Edit license",
  "licenses.create_modal.title": "Add license",
  "licenses.create": "Add new",
  "licenses.table.license": "Hash",
  "licenses.table.devices": "Devices",
  "licenses.table.is_online": "Online",
  "licenses.table.ping_at": "Last reply",
  "licenses.table.os_type": "OS Type",
  "licenses.table.smaster_version": "Smaster version",
  "licenses.common.delayed_scanning_port": "PSD",
  "licenses.common.description": "Description",
  "licenses.common.scanning_port_threshold": "SPT",
  "licenses.common.port_prefix": "PP",
  "licenses.common.is_extended_log": "Extended log",
  "licenses.common.period_clear_log": "Log cleaning period",
  "licenses.common.is_enabled": "Is enabled",
  "licenses.common.active_until": "License validity period",
  "license.delete": "Delete",
  "validation.country.not_found": "country not found",
  "validation.iccid.not_exist": "iccid id not exist",
  "validation.iccid.prefix_already_exist": "iccid prefix already exist",
  "validation.locale.not_found": "locale not found",
  "menu.sms": "Main",
  "menu.pay": "Add balance",
  "balance.payment_success": "Payment was successful",
  "balance.payment_failed": "An error occurred while paying",
  "menu.history": "Balance history",
  "menu.settings": "Account settings",
  "menu.apikey": "Your Api-key: ",
  "table.order_cancel": "Order cancelled",
  "menu.apikey_copy": "API-key copied",
  "language.ru": "Russian",
  "language.en": "English",
  "language.gb": "English",
  "ip.ip_heading2": "List of phone numbers by IP address",
  "ip.email_heading2": "List of phone numbers by email",
  "ip.phone_heading2": "List of phone numbers by phone",
  "language.es": "Spanish",
  "language.cn": "Chinese",
  "partners.common.username": "Name",
  "panel.type": "Admin mode",
  "common.not_valid": "Not valid",
  "menu.logs": "Logs",
  "ip.ip_heading": "List of users by IP address",
  "ip.email_heading": "User activity",
  "ip.phone_heading": "List of phone users",
  "ip.ips": "IP addresses",
  "ip.emails": "Email",
  "ip.phone": "Phone",
  "ip.ips_from": "IP addresses (start of interval)",
  "ip.ips_to": "IP addresses (end of interval)",
  "ip.get_data": "Get data",
  "ip.export_csv": "Download CSV",
  "ip.export_excel": "Download Excel",
  "ip.export_json": "Download JSON",
  "ip.email_error": "Please enter your email",
  "ip.ip_error": "Please enter an IP address",
  "ip.phone_error": "Please enter a phone number",
  "ip.interval_error": "The interval specified is incorrect",
  profile: "Profile",
  "front_page.body.register": "Register",
  "heading.personal": "Personal data",
  "placeholder.email": "E-mail",
  "placeholder.url": "Url",
  "placeholder.username": "Name",
  "placeholder.balance_threshold": "Balance threshold, RUB",
  "placeholder.os_type": "OS Type",
  "placeholder.description": "Description",
  "placeholder.scanning_port_threshold": "Scanning port threshold",
  "placeholder.delayed_scanning_port": "Delayed scanning port",
  "placeholder.period_clear_log": "Log cleanup period",
  "placeholder.port_prefix": "Port prefix",
  "placeholder.active_until": "License validity period",
  "placeholder.is_extended_log": "Extended log",
  "placeholder.is_enabled": "Is enabled",
  "placeholder.image": "Image",
  "modal.cancel": "Cancel",
  "modal.create": "Create",
  "confirm.agree": "Confirm your Action",
  "confirm.update_profile":
    "Are you sure you want to update your profile information?",
  "confirm.delete_rodos": "Are you sure you want to delete this Rodos?",
  "confirm.delete_iccid": "Are you sure you want to delete this ICCID?",
  "confirm.delete_license": "Are you sure you want to delete this license?",
  "form.update_data": "Update data",
  "confirm.confirm": "Confirm",
  "confirm.cancel": "Cancel",
  "login.title": "Login to the system",
  "login.subtitle": "Log in to your account",
  simbanks: "Simbanks",
  "simbanks.item.title": "Simbank",
  "simbanks.item.update": "Update all sims",
  "simbanks.partner": "Partner",
  "simbanks.port": "Port",
  coupon: "Coupon",
  "simbanks.id": "ID",
  "simbanks.model": "Model",
  "heading.partner": "Partner",
  "placeholder.hash": "Partner code",
  "pagination.show_all": "Show All",
  "pagination.hide_all": "Hide All",
  "table.per_page_all": "Per page: All",
  "heading.payout": "Withdraw funds",
  "simbanks.number": "№",
  "simbanks.license": "License",
  "simbanks.status.online": "Online",
  "simbanks.status.offline": "Offline",
  "simbanks.status.in_banks": "In simbank",
  "simbanks.status.search": "Network search ",
  "simbanks.status.no_network": "No network",
  "simbanks.status.error": "Receive error Iccid",
  "iccid.title": "ICCID - bindings",
  "iccid.prefix": "Prefix",
  "iccid.actions": "Actions",
  "iccid.operator": "Operator",
  "iccid.ussd": "USSD",
  "iccid.ussd_new": "USSD for new SIM",
  "iccid.country": "Country",
  "iccid.forwarding": "Forwarding",
  "placeholder.prefix": "Prefix",
  "placeholder.actions": "Actions",
  "placeholder.operator": "Operator",
  "placeholder.getnum_ussd": "USSD",
  "placeholder.newsim_ussd": "USSD for new SIM",
  "placeholder.country_id": "Country",
  "placeholder.forwardable": "Forwarding",
  "iccid.add": "Add ICCID",
  "iccid.edit": "Edit ICCID",
  "rodos.title": "Rodos connection settings",
  "heading.services": "Services",
  "rodos.header.title": "Rodos",
  "rodos.configuration": "Rodos config",
  "filter.search": "Search",
  "rodos.add": "Add Rodos",
  "payout.success": "Funds withdrawn successfully",
  "rodos.add.modal.title":
    "Конфигурация каналов, \n для удаления привязки введите '-' в поле устройства",
  "rodos.channel": "Channel",
  "rodos.device": "Device",
  "rodos.devices": "Devices",
  "rodos.url": "Access url",
  "nav.main": "Main",
  "nav.about": "About",
  "nav.work": "How it works?",
  "nav.services": "Services",
  "nav.faq": "FAQ",
  "nav.api": "API",
  "nav.news": "News",
  "table.per_page": "Per page",
  "nav.profile": "Profile",
  "nav.rules": "Project Rules",
  "heading.tagline": "Your service for receiving SMS online",
  "heading.payments": "Payments",
  "heading.order": "Orders",
  "heading.add_pay": "Replenishment of the balance",
  "heading.subtitle":
    "SMS-online.pro is a fully automated service for receiving SMS online. \nThis means that you do not need a mobile phone to confirm actions, activate accounts in popular services. \nYou top up your account number and receive the text of the SMS message on the screen. \nOur SMS activation site also offers you to rent a personal virtual phone number.",
  "about.text":
    "A virtual phone number online is the ability to receive messages regardless of where you are in the world. The main thing is access to the network.\nTo perform all the necessary actions on the network, you do not need a real mobile phone - the service functions regardless of whether you are in the coverage area of the mobile network or not.\nAll that is required of you is to replenish the account of your virtual number. You do not need special equipment and a sim card.",
  "about.subtitle": "Why do I need a virtual phone?",
  "about.list1":
    "If you make regular mailings, then you just need to have dozens of telephone numbers, so that the message is guaranteed to reach the subscriber.",
  "about.list2":
    "Confirm registration on social networks and other services - now you can register multiple accounts on any site that you can use for your own purposes.",
  "about.list3":
    "  You can use your virtual number to protect against spam of the main phone when registering on suspicious resources.",
  "about.subtext":
    "The main advantage of a virtual phone can be considered cheap. It turns out that you have a phone that you can use for different purposes - an unobstructed flight of your imagination is guaranteed.\n\nYour personal phone number online is a guarantee that you will always be in touch! There are situations when a person lost a phone, forgot to pay for it, accidentally left home when he was packing things up for a trip.\nTogether with us - this is no longer a problem! All you need is access to the Internet.",
  "work.subtitle":
    "Receive SMS messages to a virtual number from any available services",
  "work.text1": "Register an account on our system",
  "work.text2": "Refill your balance",
  "work.text3": "Get SMS from any service",
  "services.subtitle": "Services from which we receive SMS at the moment",
  "table.service": "Service",
  "table.date": "Date",
  "filter.datepicker": "Select date",
  "table.status": "Status",
  "table.amount": "Amount",
  "table.type": "Type",
  "text.minCount": "Min. amount",
  "text.maxCount": "Max. amount",
  "text.alotof": "A lot",
  "table.count": "Count",
  "table.price": "Price",
  "table.country": "Country",
  "table.all": "All",
  "table.not_found": "Not found",
  "table.statuses": "Status",
  "table.waiting": "Waiting",
  "table.approved": "Approved",
  "table.declined": "Declined",
  "table.canceled": "Cancelled",
  "table.failed": "Failed",
  "table.no_numbers": "No numbers",
  "table.order_create": "Order successfully created",
  "table.refill": "Refill",
  "table.balance_correction": "Balance correction",
  "table.correction": "Balance correction",
  "table.waiting_phone": "Waiting phone",
  "table.waiting_sms": "Waiting SMS",
  "table.new": "New",
  "table.finished": "Finished",
  money_rate: "Exchange rate",
  "table.dateFrom": "Date from",
  "table.dateTo": "Date to",
  "table.notFound": "No matching results",
  "world.europe": "Europe",
  "world.asia": "Asia",
  "world.africa": "Africa",
  "world.south_america": "South America",
  "world.north_america": "North America",
  "world.oceania": "Oceania",
  "world.choose": "Select country",
  "country.om": "oman",
  "country.tg": "togo",
  "country.pf": "french polynesia",
  "country.af": "afghanistan",
  "country.tf": "french southern territories",
  "country.na": "namibia",
  "country.tk": "tokelau",
  "country.dj": "djibouti",
  "country.al": "albania",
  "country.nr": "nauru",
  "country.to": "tonga",
  "country.aq": "antarctica",
  "country.ga": "gabon",
  "country.dz": "algeria",
  "country.ge": "georgia",
  "country.np": "nepal",
  "country.tt": "trinidad and tobago",
  "country.gm": "gambia",
  "country.as": "eastern samoa",
  "country.nl": "netherlands",
  "country.ae": "UAE",
  "country.an": "netherlands antilles",
  "country.ps": "state of palestine",
  "country.ad": "andorra",
  "country.de": "germany",
  "country.tn": "tunisia",
  "country.aw": "aruba",
  "country.ao": "angola",
  "country.tr": "turkey",
  "country.tm": "turkmenistan",
  "country.ag": "antigua and barbuda",
  "country.nc": "new caledonia",
  "country.tc": "turks and caicos islands",
  "country.tv": "tuvalu",
  "country.az": "azerbaijan",
  "country.ar": "argentina",
  "country.gh": "ghana",
  "country.ug": "uganda",
  "country.au": "australia",
  "country.gi": "gibraltar",
  "country.vu": "vanuatu",
  "country.ua": "ukraine",
  "country.mk": "republic of north macedonia",
  "country.at": "austria",
  "country.ki": "kiribati",
  "country.nz": "new zealand",
  "country.bs": "bahamas",
  "country.gr": "greece",
  "country.ni": "nicaragua",
  "country.bh": "bahrain",
  "country.gl": "greenland",
  "country.bd": "bangladesh",
  "country.ne": "niger",
  "country.eg": "egypt",
  "country.am": "armenia",
  "country.bb": "barbados",
  "country.gd": "grenada",
  "country.ng": "nigeria",
  "country.be": "belgium",
  "country.gp": "guadeloupe",
  "country.nu": "niue",
  "country.gb": "united kingdom of great britain and northern ireland",
  "country.bm": "bermuda",
  "country.gu": "guam",
  "country.nf": "norfolk island",
  "country.gg": "guernsey",
  "country.bt": "bhutan",
  "country.gt": "guatemala",
  "country.je": "jersey",
  "country.im": "isle of man",
  "country.no": "norway",
  "country.tz": "tanzania",
  "country.bo": "bolivia",
  "country.gn": "guinea",
  "country.mp": "northern mariana islands",
  "country.um": "united states minor outlying islands",
  "country.ba": "bosnia and herzegovina",
  "country.fm": "micronesia",
  "country.bw": "botswana",
  "country.gy": "guyana",
  "country.mh": "marshall islands",
  "country.us": "USA",
  "country.pw": "palau",
  "country.bv": "bouvet island",
  "country.pk": "pakistan",
  "country.br": "brazil",
  "country.ht": "haiti",
  "country.hm": "heard island and mcdonald islands",
  "country.pa": "panama",
  "country.va": "holy see",
  "country.vi": "virgin islands",
  "country.bz": "belize",
  "country.hn": "honduras",
  "country.io": "british territories",
  "country.pg": "papua new guinea",
  "country.bf": "burkina faso",
  "country.hk": "hong kong",
  "country.py": "paraguay",
  "country.sb": "solomon islands",
  "country.uy": "uruguay",
  "country.vg": "virgin islands, british",
  "country.hu": "hungary",
  "country.pe": "peru",
  "country.uz": "uzbekistan",
  "country.ve": "venezuela",
  "country.bn": "brunei",
  "country.is": "iceland",
  "country.ph": "philippines",
  "country.bg": "bulgaria",
  "country.in": "india",
  "country.pn": "pitcairn",
  "country.mm": "myanmar",
  "country.id": "indonesia",
  "country.pl": "poland",
  "country.bi": "burundi",
  "country.ir": "iran",
  "country.pt": "portugal",
  "country.wf": "wallis and futuna",
  "country.by": "belarus",
  "country.iq": "iraq",
  "country.gw": "guinea-bissau",
  "country.tp": "east timor",
  "country.ws": "samoa",
  "country.kh": "cambodia",
  "country.ie": "ireland",
  "country.pr": "puerto rico",
  "country.ye": "yemen",
  "country.cm": "cameroon",
  "country.il": "israel",
  "country.qa": "qatar",
  "country.ca": "canada",
  "country.it": "italy",
  "country.re": "réunion",
  "country.zm": "zambia",
  "country.tl": "timor-leste",
  "country.ci": "côte d'ivoire",
  "country.ro": "romania",
  "country.ru": "russian federation",
  "country.cv": "cape verde",
  "country.jm": "jamaica",
  "country.rw": "rwanda",
  "country.ky": "cayman islands",
  "country.jp": "japan",
  "country.cf": "central african republic",
  "country.kz": "kazakhstan",
  "country.sh": "saint helena",
  "country.lk": "sri lanka",
  "country.jo": "jordan",
  "country.kn": "saint kitts and nevis",
  "country.td": "chad",
  "country.ke": "kenya",
  "country.ai": "anguilla",
  "country.lc": "saint lucia",
  "country.cl": "chile",
  "country.kp": "democratic people's republic of korea",
  "country.kr": "korea",
  "country.pm": "saint pierre and miquelon",
  "country.cn": "china",
  "country.tw": "taiwan",
  "country.kw": "kuwait",
  "country.vc": "saint vincent and the grenadines",
  "country.kg": "kyrgyzstan",
  "country.cx": "christmas islands",
  "country.la": "lao people's democratic republic",
  "country.sm": "san marino",
  "country.cc": "cocos islands",
  "country.lb": "lebanon",
  "country.st": "sao tome and principe",
  "country.co": "colombia",
  "country.ls": "lesotho",
  "country.sa": "saudi arabia",
  "country.lv": "latvia",
  "country.km": "comoros",
  "country.lr": "liberia",
  "country.sn": "senegal",
  "country.yt": "mayotte",
  "country.rs": "serbia",
  "country.cg": "congo",
  "country.ly": "libya",
  "country.sc": "seychelles",
  "country.cd": "democratic republic of the congo",
  "country.li": "liechtenstein",
  "country.sl": "sierra leone",
  "country.ck": "cook islands",
  "country.lt": "lithuania",
  "country.lu": "luxembourg",
  "country.cr": "costa rica",
  "country.mo": "macao",
  "country.sg": "singapore",
  "country.hr": "croatia",
  "country.sk": "slovakia",
  "country.cu": "cuba",
  "country.vn": "viet nam",
  "country.si": "slovenia",
  "country.mg": "madagascar",
  "country.so": "somalia",
  "country.cy": "cyprus",
  "country.mw": "malawi",
  "country.za": "south africa",
  "country.my": "malaysia",
  "country.cz": "czechia",
  "country.bj": "benin",
  "country.zw": "zimbabwe",
  "country.mv": "maldives",
  "country.dk": "denmark",
  "country.ml": "mali",
  "country.dm": "dominica",
  "country.es": "spain",
  "country.do": "dominican republic",
  "country.mt": "malta",
  "country.ec": "ecuador",
  "country.mq": "martinique",
  "country.eh": "western sahara",
  "country.sv": "el salvador",
  "country.mr": "mauritania",
  "country.mu": "mauritius",
  "country.sd": "sudan",
  "country.gq": "equatorial guinea",
  "country.mx": "mexico",
  "country.sr": "suriname",
  "country.et": "ethiopia",
  "country.er": "eritrea",
  "country.sj": "svalbard and jan mayen",
  "country.ee": "estonia",
  "country.fo": "faroe islands",
  "country.mc": "monaco",
  "country.sz": "eswatini",
  "country.fk": "falkland islands",
  "country.gs": "south georgia and the south sandwich islands",
  "country.mn": "mongolia",
  "country.se": "sweden",
  "country.fj": "fiji",
  "country.md": "moldova",
  "country.me": "montenegro",
  "country.ms": "montserrat",
  "country.ch": "switzerland",
  "country.fi": "finland",
  "country.ax": "åland islands",
  "country.ma": "morocco",
  "country.sy": "syrian arab republic",
  "country.fr": "france",
  "country.tj": "tajikistan",
  "country.mz": "mozambique",
  "country.th": "thailand",
  "country.gf": "french guiana",
  "country.xy": "Random country",
  "country.search": "Search by country",
  "rules.content":
    "<h2>User Agreement</h2><div>1. The procedure for activation is as follows:\n• 1.1. In the left menu, select the desired social network or messenger and click 'Buy'\n• 1.2. Use the designated number, ensure that the SMS has been sent to it and click the green 'Done' button\n• 1.3. Wait for the SMS to arrive and for its content to be displayed next to the corresponding number\n• 1.4. If you need to receive more than one SMS, select 'repeat' and then send another message from this service. (Some phone numbers may not have this feature, the service does not guarantee this option or an additional fee may be charged).\n• 1.5. If everything is correct and you want to finish working with this service, click the 'Finish' button, or the activation will end automatically after a certain time (15 minutes)\n• 1.6. The maximum waiting time for SMS reception is 20 minutes, after which the number allocation ends.\n2. The cost of activations is deducted according to the price list (displayed in the menu on the user's page).\n• 2.1. Money is deducted from the balance upon completion of the operation (p.1.4,1.5 of the regulations).\n3. If the number is allocated but not used (i.e., you did not see the code from the SMS), you can cancel the operation at any time without any penalty. In case of abuse, sanctions will be applied at the discretion of the moderator.\n4. By registering on the site, you agree to receive advertising materials from SMS-online. You can unsubscribe from the mailing list at any time.\n5. The history of operations with numbers is stored in your account and is available in the top menu 'History'. The history of activations is stored indefinitely and is not subject to deletion.\n6. It is forbidden to use SMS-online for any unlawful purposes.\n• 6.1. It is forbidden to use the service for paid subscriptions.\n7. We are not responsible for the created accounts; all actions, including possible blockages, are carried out solely at the risk of the end user who purchased the activation.\n• 7.1. Activation in Qiwi and Webmoney is prohibited\n• 7.2. Activation in the banking sector is prohibited.\n8. Refund is provided only when applying to <a href='mailto:support@sms-online.pro'>support@sms-online.pro</a> from the email with which the registration was made. We also inform you that when requesting a refund upon refusal of purchase, the refund is made exclusively to the same bank card and in the same currency in which the payment was made.\n9. The warranty for numbers with forwarding is 2 weeks. If the number stops working for reasons beyond the client's control, the money will be returned.\n10. We are not responsible for incorrect programming of the API interface, or for other software errors made by the user misinterpreting the described API protocol. Refund for software errors of users is not provided.\n11. Receiving SMS from the Qiwi payment system is not provided.\n12. When paying for an order with a bank card, payment processing (including entering the card number) takes place on a secure page of the processing system, which has passed international certification. This means that your confidential data (card details, registration data, etc.) do not go to the online store, their processing is fully protected and no one, including our service, can get personal and bank details of the client. When working with card data, the information protection standard developed by the international payment systems Visa and Mastercard-Payment Card Industry Data Security Standard (PCI DSS) is used, which ensures safe processing of the Holder's Bank card details. The data transmission technology used guarantees the security of transactions with Bank cards through the use of Secure Sockets Layer (SSL) protocols, Verified by Visa, Secure Code, and closed banking networks, which have the highest degree of protection.\n13. Exploiting errors or security breaches is prohibited and will be considered by law enforcement agencies.\n14. SMS-online account is identified exclusively by the email you provided during registration.\n15. For security reasons, the administration has the right to freeze your account in the following cases:\n• 15.1. Absence of activity for 6 months \n• 15.2. Detection of suspicious/third-party activity.\n16. Restoring a frozen account is possible exclusively through the email you provided during registration.</div>",
};

export const cnTranslations = {
  "services.itemsCount": "件",
  "captcha.notice": "需要 CAPTCHA 验证",
  "CAPTCHA verification failed": "CAPTCHA 验证失败",
  "copy.email": "电子邮件已成功复制",
  "common.payment_with": "充值方式",
  "copy.address": "地址复制成功",
  "wallet.min_amount": "最低金额",
  "wallet_com.commission_payment": "补货费",
  "wallet_com.commission_network": "网络佣金",
  "tabs.all_items": "所有数字",
  "tabs.favorites": "收藏夹",
  "common.show_list": "显示服务菜单",
  "common.hide_list": "隐藏服务菜单",
  "wallet.create": "创建钱包",
  "wallet.wallet": "钱包",
  "wallet.error_title": "重要！",
  "wallet.error_text": "如果充值金额低于设定的最低金额，则资金将不会存入余额。",
  "wallet.warning_title": "所选网络与转账网络必须匹配！",
  "wallet.warning_text": "否则，存入的资金将不会记入您的余额。",
  "table.failed_refunded": "暂停",
  "common.hide_menu": "隐藏菜单",
  "common.go_to_panel": "退出管理面板",
  "common.bad_code": "错误代码",
  "common.no_numbers": "没有可用于此服务的号码",
  "services.from": "从",
  "header.language": "选择语言：",
  "date.invalid": "日期无效",
  "commission.lava": "Lava",
  copyright: "SMS-ONLINE.PRO © 保留所有权利",
  "about.plus1.title": "即时发行",
  "sorting.user.plus": "按用户：初始订单",
  "sorting.user.minus": "按用户：倒序",
  "table.failed": "失败",
  "common.go_to_settings": "前往设置",
  "common.side_show_menu": "显示/隐藏菜单",
  "common.return_to_shop": "返回商店",
  "common.six_symbols_code": "输入 6 位代码",
  "sorting.without": "不排序",
  "sorting.date.minus": "按日期：最新的在前",
  "sorting.date.plus": "按日期：最早的在前",
  "sorting.status.plus": "按状态：原始订单",
  "sorting.status.minus": "按状态：逆序",
  "common.username_forgot": "输入您的电子邮件以恢复密码",
  "common.coupon_amount": "优惠券数量",
  "about.plus1.subtitle": "您将立即获得一个专用服务号码",
  "about.plus2.title": "从任何服务接收短信",
  "about.plus2.subtitle": "我们可以从 200 多个不同的网站接收短信",
  "about.plus3.title": "按结果付款",
  "copy.phone": "手机复制成功",
  "heading.auth": "授权",
  "common.add": "添加",
  "common.payment_amount": "补货金额",
  "common.to_buy": "继续结帐",
  "heading.have_account": "已有账户？登录！",
  "heading.auth_action": "授权",
  "common.old_password": "旧密码",
  "common.choose_crypto": "选择加密货币",
  "common.numbers_after_code": "代码后的数字",
  "nav.menu.rule": "规则",
  "preloader.text": "请等待加载内容",
  "prefix.list": "排除列表",
  "common.us": "写信给我们",
  "common.turn_off": "关闭",
  "common.tg": "电报频道",
  "common.history": "历史",
  "common.auth_for": "授权购买号码",
  "common.new_password": "新密码",
  "common.confirm_password": "重复新密码",
  "common.change_password": "更改密码",
  "common.email_password": "邮箱和密码",
  "common.choose_price": "选择价格",
  "common.off": "已禁用",
  "common.on": "开启",
  "common.type.your_code": "输入您的代码",
  "2fa.get": "获取二维码",
  "table.interval": "更新间隔",
  "table.5000": "5 秒。",
  "table.10000": "10 秒。",
  "table.15000": "15 秒。",
  "table.20000": "20 秒。",
  "status.order_complete": "感谢您注册。您的确认码",
  "about.plus3.subtitle": "你只需为接收短信​​的号码付费",
  money_rate: "汇率",
  "sort.by": "排序依据",
  CountriesTop: "排名靠前的国家",
  "register.alert":
    "注意！如果您使用临时或一次性电子邮件，我们将无法恢复您帐户的访问权限或退款。",
  "2fa.notify_about_qr_off": " 要关闭双重身份验证，请输入 代码并点击“禁用”按钮",
  "table.refill": "补充",
  "table.waiting_phone": "等待电话",
  "table.waiting_sms": "等待消息",
  "table.notFound": "这里还没有内容",

  "register.alert":
    "注意力！ 如果您使用临时或一次性邮件，我们将无法恢复您帐户的访问权限或退款。",
  "search.services": "查找服务",
  "prefix.heading": "排除虚拟号码的前缀",
  "prefix.subheading":
    "要排除返回不必要的虚拟号码，您可以在下面的块中为选定的国家/地区指定它们。如果未指定或覆盖phoneException参数,则默认情况下,在指定国家/地区的API的getNumber请求中将应用排除的前缀.",
  "prefix.delete": "异常删除成功",
  "prefix.add": "添加例外",
  "prefix.edit": "编辑异常",
  "prefix.edited": "异常编辑成功",
  "prefix.added": "异常添加成功",
  "The limit 15 of phones prefix has been reached by user":
    "用户已达到15个电话前缀的限制。",
  "The length of phones prefix is invalid":
    "考虑到国家/地区代码，每个前缀的最小长度为 4 个字符",
  "Phone prefix ignore should be unique": "电话前缀必须是唯一的。",
  "button.save": "保存",
  "search.country": "查找国家",
  "auth.notice": "我已阅读并接受",
  CountriesTop: "热门国家/地区",
  "auth.agree": "用户协议。",
  "fab.telegram": "电报频道",
  "fab.mail": "电子邮件",
  "fab.support": "技术支持",
  "Invalid credentials.": "无效的数据",
  "This value is already used.": "该帐户已被注册",
  "Password have forbidden symbols": "密码包含禁止符号",
  "This value should be between 1 and 100.": "该值必须在 1 到 100 之间",
  "This value should be of type numeric.": "该值必须是数字类型",
  "This value is not a valid email address.": "该值不是电子邮件地址",
  "Can't cancel order in first two minutes": "前两分钟内无法取消订单",
  "Insufficient balance": "余额不足",
  "table.adminId": "管理员 ID",
  "theme.light": "光",
  "table.deleted": "已删除",
  "payout.success": "提现成功",
  "table.date_delete": "删除日期",
  "table.date_create": "创建日期",
  "table.delete": "删除",
  "Activation of coupons has been temporary block": "优惠券的激活已被暂时阻止",
  "table.provider": "提供商",
  "table.coupons_is_delete": "优惠券成功删除",
  notes: "条条目 第",
  to: "至",
  of: "共",
  commission: "佣金",
  "commission.0xprocessing": "加密货币",
  "commission.coupon": "优惠券",
  "commission.manual": "手动调试",
  "commission.success": "佣金更改成功",
  "menu.coupons": "优惠券",
  "filters.date_two_week":
    "允许的最长请求期限为 2 周。如果需要更长的期限，您可以将数据上传到 CSV 文件",
  "table.new": "新",
  "heading.partners_products": "合作伙伴产品",
  "table.choose_all": "全选",
  "table.deselect_all": "取消选择",
  "table.percent": "输入百分比",
  "placeholder.isPartner": "合作伙伴",
  "cookie.heading": "我们使用cookie",
  "cookie.subheading":
    "很安全：cookie 仅存储在您的设备上。如果您不介意，请单击“接受所有 cookie”或继续浏览该网站。",
  "cookie.submit": "接受所有cookie",
  "heading.partner": "合作伙伴",
  "placeholder.hash": "合作伙伴代码",
  "pagination.show_all": "显示全部",
  "pagination.hide_all": "隐藏全部",
  "table.per_page_all": "每页：全部",
  "heading.payout": "提取资金",
  "heading.partners": "合作伙伴",
  "table.activated": "已激活",
  "ip.ip_heading2": "按 IP 地址列出的电话号码列表",
  "ip.email_heading2": "通过电子邮件列出的电话号码列表",
  "heading.balance_correction": "平衡修正",
  "ip.phone_heading2": "按电话列出的电话号码列表",
  "table.expired": "已过期",
  "table.not_number": "没有编号",
  "table.coupon": "优惠券",
  "toast.coupon": "优惠券申请成功",
  "table.amount_with_commission": "金额减去佣金",
  "tabs.coupon": "优惠券",
  "tabs.crypto": "加密货币",
  "table.buy": "购买",
  "table.userId": "用户",
  "toast.coupons": "优惠券生成成功",
  "placeholder.isActivated": "已激活",
  "Coupon cannot be activated": "优惠券无法激活",
  "Coupon not found": "未找到优惠券",
  "register.resend": "重新发送链接",
  "resend.true": "一封信已发送至输入的邮箱",
  "resend.false": "发送信件的尝试次数已用尽",
  "table.not_number": "没有编号",
  "order.repeatOrderTitle": "重复短信会产生费用",
  "order.repeatOrderSubtitle": "请求短信？",
  "order.repeat_error": "重复短信未发送",
  "order.repeat_success": "重复发送短信",
  "order.cantRepeatSms": "无法重复发送短信",
  "table.buy": "购买",
  "table.order": "顺序",
  "heading.transactions": "交易",
  "table.action": "操作",
  "table.description": "描述",
  "table.state": "运行状态",
  "placeholder.registeredAt": "注册于",
  "placeholder.lastLoginAt": "上次登录日期",
  "placeholder.lastIp": "最后的 IP",
  "placeholder.currency": "货币",
  "placeholder.balance": "余额",
  "placeholder.isAdmin": "管理员权限",
  "placeholder.isSupport": "支持权利",
  "heading.user": "用户",
  coupon: "优惠券",
  filters: "过滤器",
  "Activation of coupons has been block by admin": "优惠券激活已被管理员阻止",
  "menu.admin_settings": "设置",
  "notification.order.creation_forbidden": "禁止创建订单",
  "notification.order.creation_forbidden_by_system": "系统禁止创建订单",
  "settings.is_creating_order_robust": "已启用订单接受",
  "theme.dark": "黑暗",
  "This value should be greater than or equal to dateFrom.":
    "该值应大于或等于“日期自”",
  "sorting.for": "排序依据：",
  "filter.search": "搜索",

  "sorting.date": "日期",
  "sorting.status": "状态",
  "sorting.user": "用户",
  "heading.orders": "订单",
  "heading.users": "用户",
  "stats.users": "用户总数",
  "stats.admins": "其中管理员",
  "heading.active_orders": "当前订单",
  "heading.finished_orders": "已完成的订单",
  "heading.interval": "订单更新间隔（以秒为单位）",
  "menu.stats": "统计",
  "common.change": "更改",
  "balance.empty": "充值金额不能为空",
  "balance.min": "充值金额不低于1$",
  "balance.max": "金额大于最大金额",
  "common.password_forgot": "章节恢复",
  "common.forgot": "忘记密码？",
  "common.write_mail": "输入您的密码恢复电子邮件",
  "common.forgot_info": "断电规则已发送至您的邮箱",
  "common.update_password": "输入您的新密码",
  "common.password_updated": "密码更新成功",
  "common.restore": "恢复",
  "helmet.title": "在线接收短信的虚拟号码",
  "helmet.description": "用于注册 600 多种服务的一次性号码",
  "password.length": "密码必须大于10个字符",
  "password.register": "密码必须有大小写字母",
  "password.numbers": "密码必须包含数字",
  "password.symbols": "密码必须包含特殊符号",
  money_rate: "汇率",
  "password.valid": "不满足输入密码的条件",
  "password.generate": "生成密码",
  "password.is_generated": "密码已生成并复制到剪贴板",
  "password.included_symbols": "接受的符号：",
  "password.excluded_symbols": "密码必须仅包含有效符号",
  "register.notify":
    "您需要通过邮件确认您的帐户。\n请点击信中的链接。\n\n它可能已落入垃圾邮件文件夹中",
  "register.login_notify": "需要电子邮件确认",
  "register.email": "电子邮件确认成功",
  "about.list1":
    "如果您定期发送邮件，那么您必须有数十个电话号码，以确保消息可靠地传达给订阅者。",
  "about.list2":
    "在社交网络和其他服务中确认注册 - 现在您可以在任何网站上注册多个帐户，并用于自己的目的。",
  "about.list3":
    "您可以使用您的虚拟号码来保护主要电话免受在可疑资源上注册时的垃圾邮件的侵害",
  "about.subtext":
    "虚拟电话的主要优势是它的便宜。这意味着您有一个电话，您可以用于各种目的 - 您的想象力可以自由飞翔。\n\n您的个人在线电话号码是您始终保持联系的保证！有时人们会丢失电话，忘记支付费用，或在出行时不小心留在家里。\n有了我们，这不再是问题！您需要的只是互联网访问。",
  "about.subtitle": "虚拟电话有什么用？",
  "about.text":
    "在线虚拟电话号码是您可以接收消息的能力，无论您身在地球的哪个角落。最重要的是有网络访问。\n为了在网络上执行所有必要的操作，您不需要真正的移动电话 - 该服务可以独立于您是否在移动网络覆盖区域内工作。\n您需要做的就是为您的虚拟号码充值。您不需要特殊的设备和SIM卡。",
  "balance.payment_failed": "付款失败",
  "balance.payment_success": "付款成功",
  "common.action": "行动",
  "common.balance": "余额",
  "common.cancel": "取消",
  "common.confirmation.delete_body": "确认删除操作",
  "common.confirmation.delete_title": "注意！",
  "common.email": "电子邮件",
  "common.id": "ID",
  "common.login": "登录",
  "common.logout": "登出",
  "placeholder.isActivateCouponRestricted": "优惠券激活受限",
  "common.notifications.fetch_create_error": "创建时发生错误",
  "common.notifications.fetch_data_error": "无法获取数据",
  "common.password": "密码",
  "common.phone": "电话",
  "common.pu": "PU",
  "common.registration": "注册",
  "common.state": "状态",
  "common.submit": "提交",
  "common.username": "用户名",
  "confirm.agree": "确认操作",
  "confirm.cancel": "取消",
  "confirm.confirm": "确认",
  "common.submit_form": "提交",
  "phone.not_found": "未找到手机",
  "common.yes": "是",
  "common.no": "否",
  "table.email_confirmed": "电子邮件已确认",
  "common.generate_api": "生成新密钥",
  "heading.api": "API 密钥",
  "heading.api_notify": "确认邮件已发送。链接有效期为 2 小时。",
  "heading.api_text": "生成 API 密钥以通过 API 协议与网站交互",
  "api.new": "新的 API 密钥创建成功",
  "api.copy": "复制 API 密钥",
  "api.modal_text": "使用它通过 API 协议与站点交互",
  "api.modal_security": "出于安全原因，此 API 密钥只会显示一次。",
  "api.modal_save": "请保存",
  "api.error_modal": "您已经为此请求请求了 API 密钥，或者它已过期",
  "2fa.enable": "双因素身份验证",
  "2fa.notify_about_qr": "必须确认身份验证才能启用。请输入下面的验证码",
  "2fa.login": "输入您的验证码进行登录",
  "table.few": "很少",
  "2fa.cancel": "您确定要取消 2FA 吗？",
  "2fa.stores": "下载应用程序扫描二维码",
  "common.your_code": "您的代码",
  "country.ad": "安道尔",
  "country.ae": "阿拉伯联合酋长国",
  "country.af": "阿富汗",
  "country.ag": "安提瓜和巴布达",
  "country.ai": "安圭拉",
  "country.al": "阿尔巴尼亚",
  "country.am": "亚美尼亚",
  "country.an": "荷属安的列斯",
  "country.ao": "安哥拉",
  "country.aq": "南极洲",
  "country.ar": "阿根廷",
  "country.as": "美属萨摩亚",
  "country.at": "奥地利",
  "country.au": "澳大利亚",
  "country.aw": "阿鲁巴",
  "country.ax": "奥兰群岛",
  "country.az": "阿塞拜疆",
  "country.ba": "波斯尼亚和黑塞哥维那",
  "country.bb": "巴巴多斯",
  "country.bd": "孟加拉国",
  "country.be": "比利时",
  "country.bf": "布基纳法索",
  "country.bg": "保加利亚",
  "country.bh": "巴林",
  "country.bi": "布隆迪",
  "country.bj": "贝宁",
  "country.bm": "百慕大",
  "country.bn": "文莱",
  "country.bo": "玻利维亚",
  "country.br": "巴西",
  "country.bs": "巴哈马",
  "country.bt": "不丹",
  "country.bv": "布维岛",
  "country.bw": "博茨瓦纳",
  "country.by": "白俄罗斯",
  "country.bz": "伯利兹",
  "country.ca": "加拿大",
  "country.cc": "科科斯（基林）群岛",
  "country.cd": "刚果（金）",
  "country.cf": "中非共和国",
  "country.cg": "刚果（布）",
  "country.ch": "瑞士",
  "country.ci": "科特迪瓦",
  "country.ck": "库克群岛",
  "country.cl": "智利",
  "country.cm": "喀麦隆",
  "country.cn": "中国",
  "country.co": "哥伦比亚",
  "country.cr": "哥斯达黎加",
  "country.cu": "古巴",
  "country.cv": "佛得角",
  "country.cx": "圣诞岛",
  "country.cy": "塞浦路斯",
  "country.cz": "捷克",
  "country.de": "德国",
  "country.dj": "吉布提",
  "country.dk": "丹麦",
  "country.dm": "多米尼克",
  "country.do": "多米尼加共和国",
  "country.dz": "阿尔及利亚",
  "country.ec": "厄瓜多尔",
  "country.ee": "爱沙尼亚",
  "country.eg": "埃及",
  "country.eh": "西撒哈拉",
  "country.er": "厄立特里亚",
  "country.es": "西班牙",
  "country.et": "埃塞俄比亚",
  "country.fi": "芬兰",
  "country.fj": "斐济",
  "country.fk": "福克兰群岛",
  "country.fm": "密克罗尼西亚",
  "country.fo": "法罗群岛",
  "country.fr": "法国",
  "country.ga": "加蓬",
  "country.gb": "英国",
  "country.gd": "格林纳达",
  "country.ge": "格鲁吉亚",
  "country.gf": "法属圭亚那",
  "country.gg": "根西岛",
  "country.gh": "加纳",
  "country.gi": "直布罗陀",
  "country.gl": "格陵兰",
  "country.gm": "冈比亚",
  "country.gn": "几内亚",
  "country.gp": "瓜德罗普",
  "country.gq": "赤道几内亚",
  "country.gr": "希腊",
  "country.gs": "南乔治亚岛和南桑威奇群岛",
  "country.gt": "危地马拉",
  "country.gu": "关岛",
  "country.gw": "几内亚比绍",
  "country.gy": "圭亚那",
  "country.hk": "香港",
  "country.hm": "赫德岛和麦克唐纳群岛",
  "country.hn": "洪都拉斯",
  "country.hr": "克罗地亚",
  "country.ht": "海地",
  "country.hu": "匈牙利",
  "country.id": "印度尼西亚",
  "country.ie": "爱尔兰",
  "country.il": "以色列",
  "country.im": "马恩岛",
  "country.in": "印度",
  "country.io": "英属印度洋领地",
  "country.iq": "伊拉克",
  "country.ir": "伊朗",
  "country.is": "冰岛",
  "country.it": "意大利",
  "country.je": "泽西岛",
  "country.jm": "牙买加",
  "country.jo": "约旦",
  "country.jp": "日本",
  "country.ke": "肯尼亚",
  "country.kg": "吉尔吉斯斯坦",
  "country.kh": "柬埔寨",
  "country.ki": "基里巴斯",
  "country.km": "科摩罗",
  "country.kn": "圣基茨和尼维斯",
  "country.kp": "朝鲜",
  "country.kr": "韩国",
  "country.kw": "科威特",
  "country.ky": "开曼群岛",
  "country.kz": "哈萨克斯坦",
  "country.la": "老挝",
  "country.lb": "黎巴嫩",
  "country.lc": "圣卢西亚",
  "country.li": "列支敦士登",
  "country.lk": "斯里兰卡",
  "country.lr": "利比里亚",
  "country.ls": "莱索托",
  "country.lt": "立陶宛",
  "country.lu": "卢森堡",
  "country.lv": "拉脱维亚",
  "country.ly": "利比亚",
  "country.ma": "摩洛哥",
  "country.mc": "摩纳哥",
  "country.md": "摩尔多瓦",
  "country.me": "黑山",
  "country.mg": "马达加斯加",
  "country.mh": "马绍尔群岛",
  "country.mk": "北马其顿",
  "country.ml": "马里",
  "country.mm": "缅甸",
  "country.mn": "蒙古",
  "country.mo": "澳门",
  "country.mp": "北马里亚纳群岛",
  "country.mq": "马提尼克",
  "country.mr": "毛里塔尼亚",
  "country.ms": "蒙特塞拉特",
  "country.mt": "马耳他",
  "country.mu": "毛里求斯",
  "country.mv": "马尔代夫",
  "country.mw": "马拉维",
  "country.mx": "墨西哥",
  "country.my": "马来西亚",
  "country.mz": "莫桑比克",
  "country.na": "纳米比亚",
  "country.nc": "新喀里多尼亚",
  "country.ne": "尼日尔",
  "country.nf": "诺福克岛",
  "country.ng": "尼日利亚",
  "country.ni": "尼加拉瓜",
  "country.nl": "荷兰",
  "country.no": "挪威",
  "country.np": "尼泊尔",
  "country.nr": "瑙鲁",
  "country.nu": "纽埃",
  "country.nz": "新西兰",
  "country.om": "阿曼",
  "country.pa": "巴拿马",
  "country.pe": "秘鲁",
  "country.pf": "法属波利尼西亚",
  "country.pg": "巴布亚新几内亚",
  "country.ph": "菲律宾",
  "country.pk": "巴基斯坦",
  "country.pl": "波兰",
  // "country.pm": "圣皮埃尔和密克隆"
  "country.pn": "皮特凯恩群岛",
  "country.pr": "波多黎各",
  "country.ps": "巴勒斯坦领土",
  "country.pt": "葡萄牙",
  "country.pw": "帕劳",
  "country.py": "巴拉圭",
  "country.qa": "卡塔尔",
  "country.re": "留尼汪",
  "country.ro": "罗马尼亚",
  "country.rs": "塞尔维亚",
  "country.ru": "俄罗斯",
  "country.rw": "卢旺达",
  "country.sa": "沙特阿拉伯",
  "country.sb": "所罗门群岛",
  "country.sc": "塞舌尔",
  "country.sd": "苏丹",
  "country.se": "瑞典",
  "country.sg": "新加坡",
  "country.sh": "圣赫勒拿",
  "country.si": "斯洛文尼亚",
  "country.sj": "斯瓦尔巴特和扬马延",
  "country.sk": "斯洛伐克",
  "country.sl": "塞拉利昂",
  "country.sm": "圣马力诺",
  "country.sn": "塞内加尔",
  "country.so": "索马里",
  "country.sr": "苏里南",
  "country.st": "圣多美和普林西比",
  "country.sv": "萨尔瓦多",
  "country.sy": "叙利亚",
  "country.sz": "斯威士兰",
  "country.tc": "特克斯和凯科斯群岛",
  "country.td": "乍得",
  "country.tf": "法属南部领地",
  "country.tg": "多哥",
  "country.th": "泰国",
  "country.tj": "塔吉克斯坦",
  "country.tk": "托克劳",
  "country.tl": "东帝汶",
  "country.tm": "土库曼斯坦",
  "country.tn": "突尼斯",
  "country.to": "汤加",
  "country.tr": "土耳其",
  "country.tt": "特立尼达和多巴哥",
  "country.tv": "图瓦卢",
  "country.tw": "台湾",
  "country.tz": "坦桑尼亚",
  "country.ua": "乌克兰",
  "country.ug": "乌干达",
  "country.um": "美国本土外小岛屿",
  "country.us": "美国",
  "country.uy": "乌拉圭",
  "country.uz": "乌兹别克斯坦",
  "country.va": "梵蒂冈",
  "country.vc": "圣文森特和格林纳丁斯",
  "country.ve": "委内瑞拉",
  "country.vg": "英属维尔京群岛",
  "country.vi": "美属维尔京群岛",
  "country.vn": "越南",
  "country.vu": "瓦努阿图",
  "country.wf": "瓦利斯和富图纳",
  "country.ws": "萨摩亚",
  "country.ye": "也门",
  "country.yt": "马约特",
  "country.za": "南非",
  "country.zm": "赞比亚",
  "country.zw": "津巴布韦",
  "filter.datepicker": "选择日期",
  "form.update_data": "更新数据",
  "front_page.body.register": "注册",
  "heading.add_pay": "充值",
  "heading.order": "您的订单",
  "heading.payments": "您的付款",
  "heading.services": "服务",
  "heading.subtitle":
    "SMS-online.pro 是一种在线接收短信的全自动服务。\n这意味着您不需要手机来确认操作或激活流行服务中的帐户。\n您充值您的帐号并在屏幕上接收短信文本。\n我们的短信激活网站还为您提供租用个人虚拟电话号码的服务。",
  "heading.tagline": "您的在线接收短信服务",
  "language.en": "英语",
  "language.gb": "英语",
  "language.ru": "俄语",
  "language.es": "西班牙语",
  "language.cn": "中国人",
  "login.subtitle": "登录您的帐户",
  "login.title": "系统登录",
  "menu.apikey": "您的Api密钥：",
  "menu.apikey_copy": "API密钥已复制",
  "menu.history": "余额历史",
  "menu.pay": "充值",
  "menu.settings": "帐户设置",
  "menu.sms": "主页",
  "modal.cancel": "关闭",
  "modal.create": "创建",
  "nav.about": "关于我们",
  "nav.api": "API",
  "nav.faq": "常见问题",
  "nav.main": "主页",
  "nav.news": "新闻",
  "nav.profile": "个人中心",
  "nav.rules": "项目规则",
  "nav.services": "服务",
  "nav.work": "如何工作？",
  "placeholder.description": "描述",
  "placeholder.email": "电子邮件",
  "placeholder.image": "图片",
  "placeholder.is_enabled": "已启用",
  "placeholder.url": "网址",
  "placeholder.username": "用户名",
  "panel.type": "管理员模式",
  "common.not_valid": "无效",
  "menu.logs": "日志",
  "ip.ip_heading": "按 IP 地址列出的用户列表",
  "ip.email_heading": "用户活动",
  "ip.phone_heading": "电话用户列表",
  "ip.ips": "IP 地址",
  "ip.emails": "电子邮件",
  "ip.phone": "电话",
  "ip.ips_from": "IP 地址（间隔开始）",
  "ip.ips_to": "IP 地址（间隔结束）",
  "ip.get_data": "获取数据",
  "ip.export_csv": "下载 CSV",
  "ip.export_excel": "下载 Excel",
  "ip.export_json": "下载 JSON",
  "ip.email_error": "请输入您的电子邮件",
  "ip.ip_error": "请输入IP地址",
  "ip.phone_error": "请输入电话号码",
  "ip.interval_error": "指定的时间间隔不正确",
  profile: "个人资料",
  "services.subtitle": "我们目前接受短信的服务",
  "table.all": "全部",
  "table.amount": "金额",
  "table.approved": "已批准",
  "table.balance_correction": "余额校正",
  "table.correction": "余额校正",

  "table.canceled": "已取消",
  "table.count": "数量",
  "table.country": "国家",
  "table.date": "日期",
  "table.dateFrom": "开始日期",
  "table.dateTo": "结束日期",
  "table.declined": "已拒绝",
  "table.failed": "失败",
  "table.finished": "已完成",
  "table.new": "新的",
  "table.no_numbers": "没有号码",
  "table.notFound": "找不到合适的结果",
  "table.not_found": "未找到",
  "table.order_cancel": "订单已取消",
  "table.order_create": "订单已成功创建",
  "table.per_page": "每页",
  "table.price": "价格",
  "table.refill": "充值",
  "table.service": "服务",
  "table.sms_content": "短信",
  "table.status": "状态",
  "table.statuses": "状态",
  "table.type": "类型",
  "table.waiting": "等待中",
  "table.waiting_phone": "等待来电",
  "table.waiting_sms": "等待消息",
  "text.alotof": "很多",
  "text.maxCount": "最大金额",
  "text.minCount": "最小金额",
  "work.subtitle": "接收来自任何可用服务的虚拟号码短信",
  "work.text1": "在我们的系统中注册帐户",
  "work.text2": "充值",
  "work.text3": "从任何服务接收短信",
  "world.africa": "非洲",
  "world.asia": "亚洲",
  "world.choose": "选择国家",
  "world.europe": "欧洲",
  "world.north_america": "北美",
  "world.oceania": "大洋洲",
  "world.south_america": "南美",
  "rules.content":
    "<h2>用</h2><div>1. 激活过程如下：\n• 1.1. 在左侧菜单中选择所需的社交网络或信使，然后点击'购买'\n• 1.2. 使用指定的号码，确保已将短信发送至该号码，然后点击绿色的'完成'按钮\n• 1.3. 等待短信到达，并在相应号码旁边显示其内容\n• 1.4. 如果您需要接收多于一条短信，请选择“重复”，然后从此服务发送另一条消息。（某些电话号码可能没有此功能，服务不保证此选项，或可能会收取额外费用）。\n• 1.5. 如果一切正确，您想要完成使用此服务，请点击“完成”按钮，或者激活将在一定时间（15分钟）后自动结束\n• 1.6. 接收短信的最长等待时间为20分钟，之后将结束号码分配。\n2. 激活费用将根据价格表（显示在用户页面的菜单中）扣除。\n• 2.1 在操作完成时（规定的1.4,1.5点）从余额中扣除款项。\n3. 如果号码已分配但未使用（即您没有看到短信中的代码），您可以随时取消操作，无需任何处罚。在滥用的情况下，将由主持人自行决定是否应用制裁。\n4. 在网站上注册，您同意接收来自SMS-online的广告材料。您可以随时取消订阅。\n5. 号码操作历史记录存储在您的账户中，并可在顶部菜单“历史”中查看。激活历史记录将无限期存储，不予删除。\n6. 禁止将SMS-online用于任何非法目的。\n• 6.1. 禁止使用该服务进行付费订阅。\n7. 我们对创建的账户不承担任何责任；所有操作，包括可能的阻止，都是由购买激活的最终用户承担风险。\n• 7.1. 禁止在Qiwi和Webmoney中进行激活\n• 7.2. 禁止在银行部门进行激活。\n8. 仅在从注册邮箱发送申请至<a href='mailto:support@sms-online.pro'>support@sms-online.pro</a>时提供退款。我们还通知您，在拒绝购买时要求退款时，退款将仅退还至以相同货币进行支付的相同银行卡上。\n9. 转发号码的保修期为2周。如果号码因客户无法控制的原因停止工作，款项将被退还。\n10. 我们不对API接口的编程错误或用户由于误解所描述的API协议而造成的其他软件错误负责。不提供用户软件错误的退款。\n11. 不提供来自Qiwi支付系统的短信接收。\n12. 用银行卡支付订单时，付款处理（包括输入卡号）将在已通过国际认证的处理系统的安全页面上进行。这意味着您的机密数据（卡详细信息、注册数据等）不会进入在线商店，完全受到保护，包括我们的服务，没有人可以获取客户的个人和银行数据。在处理卡数据时，使用由国际支付系统Visa和Mastercard-Payment Card Industry Data Security Standard（PCI DSS）制定的信息保护标准，确保安全处理持卡人的银行卡详细信息。所使用的数据传输技术通过使用Secure Sockets Layer（SSL）协议、Verified by Visa、Secure Code和封闭的具有最高保护级别的银行网络，保证了与银行卡的交易安全。\n13. 禁止利用系统安全中的错误或漏洞，将由执法机构考虑。\n14. SMS-online帐户仅通过您在注册时提供的电子邮件进行识别。\n15. 出于安全考虑，管理员有权在以下情况下冻结您的账户： \n• 15.1. 6个月无活动 \n• 15.2. 检测到可疑/第三方活动。\n16. 仅通过您在注册时提供的电子邮件恢复冻结的账户。</div>",
};

export const esTranslations = {
  "captcha.notice": "Se requiere verificación CAPTCHA",
  "CAPTCHA verification failed": "Error en la verificación CAPTCHA",
  "common.hide_menu": "Ocultar menú",
  "common.show_list": "Mostrar menú de servicios",
  "common.hide_list": "Ocultar el menú de servicios",
  "header.language": "Elija idioma:",
  "tabs.all_items": "Todos los números",
  "wallet.min_amount": "Monto mínimo",
  "wallet_com.commission_payment": "Tarifa de reposición",
  "wallet_com.commission_network": "Comisión de red",
  "tabs.favorites": "Favoritos",
  "common.go_to_panel": "Salir panel de administración",
  "sorting.without": "Sin clasificación",
  "theme.light": "Luz",
  "filter.search": "Buscar",
  "copy.email": "Correo electrónico copiado exitosamente",
  "common.bad_code": "Código incorrecto",
  "common.no_numbers": "No hay números disponibles para este servicio",
  commission: "Comisión",
  CountriesTop: "Países principales",
  "sorting.user.plus": "Por usuario: pedido inicial",
  "sorting.user.minus": "Por usuarios: orden inverso",
  "table.failed": "Error",
  "common.go_to_settings": "Ir a configuración",
  "common.side_show_menu": "Mostrar/ocultar menú",
  "common.return_to_shop": "Volver a la tienda",
  "table.failed_refunded": "Se acabó el tiempo",
  "common.six_symbols_code": "Ingrese el código de 6 dígitos",
  "order.repeatOrderTitle": "Repetir SMS tendrá un coste",
  "order.repeatOrderSubtitle": "¿Solicitar SMS?",
  "order.repeat_error": "El SMS repetido no fue enviado",
  "order.repeat_success": "Repetir SMS enviado",
  "sorting. without": "Sin ordenar",
  "sorting.date.minus": "Por fecha: más nuevo primero",
  "sorting.date.plus": "Por fecha: el más antiguo primero",
  "sorting.status.plus": "Por estado: pedido original",
  "sorting.status.minus": "Por estado: orden inverso",
  "common.username_forgot":
    "Ingresa tu correo electrónico para recuperar tu contraseña",
  "common.coupon_amount": "Número de cupón",
  "order.cantRepeatSms": "No se puede repetir el envío de SMS",
  money_rate: "Tipo de cambio",
  "common.username_forgot":
    "Ingresa tu correo electrónico para recuperar tu contraseña",
  "heading.balance_correction": "Corrección de saldo",
  "commission.0xprocessing": "Criptomoneda",
  "commission.coupon": "Cupones",
  "commission.manual": "Puesta en servicio manual",
  "commission.success": "La comisión cambió exitosamente",
  "register.alert":
    "¡Atención! No podremos restaurar el acceso a su cuenta ni emitir un reembolso si utiliza correo temporal o desechable.",
  "filters.date_two_week":
    "El período de solicitud máximo permitido es de 2 semanas. Si se necesita un período más largo, puede cargar los datos en un archivo CSV",
  "heading.transactions": "Transacciones",
  "prefix.heading": "Excluir prefijos para números virtuales",
  "prefix.subheading":
    "Para excluir la devolución de números virtuales innecesarios, puede especificarlos para el país seleccionado en el bloque siguiente. Los prefijos excluidos se aplicarán de forma predeterminada en la solicitud getNumber a la API para el país especificado si el parámetro phoneException no se especifica o se anula .",
  "prefix.delete": "Excepción eliminada exitosamente",
  "prefix.add": "Agregar excepción",
  "prefix.edit": "Edición de excepción",
  "prefix.edited": "Excepción editada exitosamente",
  "prefix.added": "Excepción agregada exitosamente",
  "The limit 15 of phones prefix has been reached by user":
    "El usuario ha alcanzado el límite de 15 prefijos telefónicos.",
  "The length of phones prefix is invalid":
    "La longitud mínima de cada prefijo, teniendo en cuenta el código del país, es de 4 caracteres",
  "Phone prefix ignore should be unique":
    "El prefijo telefónico debe ser único.",
  "button.save": "Guardar",
  "table.action": "Acción",
  "auth.notice": "He leído y acepto",
  "auth.agree": "Acuerdo de usuario.",
  "fab.telegram": "Canal de Telegram",
  "fab.mail": "Correo electrónico",
  "fab.support": "Soporte Técnico",
  "services.itemsCount": "pcs",
  "services.from": "de",
  "date.invalid": "Fecha no válida",
  "search.services": "Encontrar un servicio",
  "search.country": "Buscar país",
  notes: "Entradas",
  to: "a",
  of: "de",
  "ip.ip_heading2": "Lista de números de teléfono por dirección IP",
  "ip.email_heading2": "Lista de números de teléfono por correo electrónico",
  "ip.phone_heading2": "Lista de números de teléfono por teléfono",
  coupon: "Cupón",
  "heading.partners_products": "Productos de socios",
  "table.choose_all": "Seleccionar todo",
  "table.deselect_all": "Deseleccionar",
  "phone.not_found": "No se encontraron teléfonos",
  "table.percent": "Ingrese el porcentaje",
  "placeholder.isPartner": "Socio",
  "table.amount_with_commission": "Monto menos comisión",
  "heading.partners": "Socios",
  "This value should be greater than or equal to dateFrom.":
    "Este valor debe ser mayor o igual a 'fecha de'",
  "placeholder.isActivateCouponRestricted": "Activacion de cupon restringida",
  "table.deleted": "Eliminado",
  "table.date_delete": "Eliminar fecha",
  "table.date_create": "Fecha de creación",
  "table.delete": "Eliminar",
  "table.coupons_is_delete": "Cupones eliminados exitosamente",
  "menu.coupons": "Cupones",
  "table.new": "Nuevo",
  "table.activated": "Activado",
  "table.expired": "Caducado",
  "table.not_number": "Sin número",
  "table.coupon": "Cupón",
  "toast.coupon": "Cupón aplicado correctamente",
  "tabs.coupon": "Cupón",
  "tabs.crypto": "Criptomoneda",
  "table.buy": "Comprar",
  copyright: "SMS-ONLINE.PRO © Todos los derechos reservados",
  "about.plus1.title": "Emisión instantánea",
  "about.plus1.subtitle":
    "Obtendrás un número dedicado instantáneamente para tu servicio",
  "about.plus2.title": "Recibir SMS de cualquier servicio",
  "about.plus2.subtitle":
    "Más de 200 sitios diferentes desde los que podemos recibir SMS",
  "about.plus3.title": "Pago por resultados",
  "copy.phone": "Teléfono copiado exitosamente",
  "heading.auth": "Autorización",
  "common.payment_with": "Recarga con",
  "copy.address": "Dirección copiada exitosamente",
  "wallet.create": "Crear billetera",
  "wallet.wallet": "Billetera",
  "wallet.error_title": "¡Importante!",
  "wallet.error_text":
    "Si el importe de reposición es inferior al mínimo establecido, el dinero no se acreditará al saldo.",
  "wallet.warning_title":
    "¡La red seleccionada y la red de transferencia deben coincidir!",
  "wallet.warning_text":
    "De lo contrario, los fondos depositados no se acreditarán a su saldo.",
  "common.add": "Agregar",
  "common.payment_amount": "Monto de reposición",
  "common.to_buy": "Proceder al pago",
  "heading.have_account": "¿Ya tienes una cuenta? ¡Inicia sesión!",
  "heading.auth_action": "Autorizar",
  "common.old_password": "Contraseña anterior",
  "common.choose_crypto": "Elija criptomoneda",
  "common.numbers_after_code": "Números después del código",
  "nav.menu.rule": "Reglas",
  "preloader.text": "Por favor espere mientras se carga el contenido",
  "prefix.list": "Lista de exclusión",
  "common.us": "Escríbanos",
  "common.turn_off": "Apagar",
  "common.tg": "Canal de Telegram",
  "common.history": "Historial",
  "common.auth_for": "Autorizar la compra de números",
  "common.new_password": "Nueva contraseña",
  "common.confirm_password": "Repetir nueva contraseña",
  "common.change_password": "Cambiar contraseña",
  "common.email_password": "Correo electrónico y contraseña",
  "common.choose_price": "Elegir precio",
  "common.off": "Deshabilitado",
  "common.on": "Activado",
  "common.type.your_code": "Ingresa tu código",
  "2fa.get": "Obtener código QR",
  "table.interval": "Intervalo de actualización",
  "table.5000": "5 seg.",
  "table.10000": "10 seg.",
  "table.15000": "15 seg.",
  "table.20000": "20 seg.",
  "status.order_complete": "Gracias por registrarse. Su código de confirmación",
  "about.plus3.subtitle": "Pagas sólo por los números que reciben SMS",
  money_rate: "Tipo de cambio",
  "sort.by": "Ordenar por",
  CountriesTop: "Los mejores países",
  "registrar.alerta":
    "¡Atención! No podremos restaurar el acceso a su cuenta ni realizar un reembolso si utiliza un correo electrónico temporal o desechable",
  "2fa.notify_about_qr_off":
    "Para desactivar la autenticación de dos factores clic en el botón “Deshabilitar”",
  "table.refill": "Rellenar",
  "table.waiting_phone": "Esperando una llamada",
  "table.waiting_sms": "Esperando mensajes",
  "table.notFound": "No hay nada aquí todavía",
  "cookie.heading": "Usamos cookies",
  "cookie.subheading":
    'Es seguro: las cookies sólo se almacenan en su dispositivo. Si no le importa, haga clic en "Aceptar todas las cookies" o continúe navegando por el sitio.',
  "cookie.submit": "Aceptar todas las cookies",
  "heading.partner": "Socio",
  "placeholder.hash": "Código de socio",
  "pagination.show_all": "Mostrar todo",
  "pagination.hide_all": "Ocultar todo",
  "table.per_page_all": "Por página: Todo",
  "heading.payout": "Retirar fondos",
  "table.userId": "Usuario",
  coupon: "Cupón",
  "toast.coupons": "Cupones generados exitosamente",
  "placeholder.isActivated": "Activado",
  "Coupon cannot be activated": "El cupón no se puede activar",
  "Coupon not found": "Cupón no encontrado",
  "table.description": "Descripción",
  "table.state": "Estado de operación",
  "placeholder.registeredAt": "Registrado en",
  "placeholder.lastLoginAt": "Última fecha de inicio de sesión",
  "placeholder.lastIp": "Última IP",
  "placeholder.currency": "Moneda",
  "placeholder.balance": "Saldo",
  "table.order": "Orden",
  "placeholder.isAdmin": "Derechos de administrador",
  "placeholder.isSupport": "Derechos de soporte",
  "heading.user": "Usuario",
  "register.resend": "Reenviar enlace",
  "resend.true": "Se ha enviado una carta al correo electrónico ingresado",
  "resend.false": "Se ha agotado el número de intentos de enviar la carta",
  "Invalid credentials.": "Datos no válidos",
  "This value is already used.": "Esta cuenta ya ha sido registrada",
  "Password have forbidden symbols":
    "La contraseña contiene símbolos prohibidos",
  "This value should be between 1 and 100.":
    "El valor debe estar entre 1 y 100",
  "This value should be of type numeric.": "El valor debe ser de tipo numérico",
  "This value is not a valid email address.":
    "El valor no es una dirección de correo electrónico",
  "Can't cancel order in first two minutes":
    "No se puede cancelar el pedido en los primeros dos minutos",
  "table.not_number": "Sin número",
  "commission.lava": "Lava",
  "table.buy": "Comprar",
  filters: "Filtros",
  "Activation of coupons has been block by admin":
    "El administrador ha bloqueado la activación de cupones",
  "table.provider": "Proveedor",
  "Insufficient balance": "Saldo insuficiente",
  "notification.order.creation_forbidden": "Creación de pedidos prohibida",
  "notification.order.creation_forbidden_by_system":
    "El sistema prohíbe crear pedidos",
  "menu.admin_settings": "Configuración",
  "settings.is_creating_order_robust": "Aceptación de pedidos habilitada",
  "theme.dark": "Oscuro",
  "sorting.for": "Ordenar por:",
  "sorting.date": "Fecha",
  "sorting.status": "Estado",
  "sorting.user": "Usuarios",
  "common.change": "Cambiar",
  "balance.empty": "El monto de la recarga no puede estar vacío",
  "heading.orders": "Pedidos",
  "heading.users": "Usuarios",
  "Activation of coupons has been temporary block":
    "La activación de cupones ha sido un bloqueo temporal.",
  "table.email_confirmed": "Correo electrónico confirmado",
  "stats.users": "Usuarios totales",
  "stats.admins": "De los cuales administradores",
  "heading.active_orders": "Pedidos actuales",
  "heading.finished_orders": "Pedidos completados",
  "heading.interval": "Intervalo de actualización de pedidos (en segundos)",
  "menu.stats": "Estadísticas",
  "balance.min": "El monto del depósito no es inferior a 1$",
  "common.password_forgot": "Restaurar capítulo",
  "common.forgot": "¿Olvidaste tu contraseña?",
  "common.write_mail":
    "Ingrese su correo electrónico de recuperación de contraseña",
  "common.forgot_info":
    "Se ha enviado una regla de restauración de energía a tu correo electrónico",
  "common.update_password": "Ingrese su nueva contraseña",
  "common.password_updated": "Contraseña actualizada correctamente",
  "common.restore": "Restaurar",
  "balance.max": "Cantidad mayor que la cantidad máxima",
  "helmet.title": "Números virtuales para recibir SMS online ",
  "helmet.description":
    "Números desechables para registro en más de 600 servicios",
  "password.length": "La contraseña debe tener más de 10 caracteres",
  "password.register":
    "La contraseña debe tener letras mayúsculas y minúsculas",
  "password.numbers": "La contraseña debe contener números",
  "password.symbols": "La contraseña debe contener símbolos especiales",
  "password.valid":
    "No se cumplieron las condiciones para ingresar la contraseña",
  "password.generate": "Generar contraseña",
  "password.is_generated":
    "La contraseña ha sido generada y copiada al portapapeles",
  "password.included_symbols": "Símbolos aceptados: ",
  "password.excluded_symbols":
    "La contraseña debe contener sólo símbolos válidos",
  "register.notify":
    "Debes confirmar tu cuenta por correo.\nSigue el enlace de la carta.\n\nEs posible que haya caído en la carpeta SPAM.",
  "register.login_notify": "Se requiere confirmación por correo electrónico",
  "register.email": "Correo electrónico confirmado exitosamente",
  "about.list1":
    "Si realiza envíos regulares, es esencial tener decenas de números de teléfono para asegurarse de que el mensaje llegue al suscriptor.",
  "about.list2":
    "Confirme registros en redes sociales y otros servicios: ahora puede registrar múltiples cuentas en cualquier sitio web para sus propios propósitos.",
  "about.list3":
    "Puede usar su número virtual para protegerse del spam en su teléfono principal al registrarse en sitios sospechosos.",
  "about.subtext":
    "La principal ventaja de un teléfono virtual es su bajo costo. Es como tener un teléfono que puede usar para diferentes propósitos: la libertad para su imaginación está garantizada. Su número de teléfono personal en línea asegura que siempre estará conectado. Hay situaciones en las que alguien pierde su teléfono, olvida pagar por él, lo deja accidentalmente en casa cuando empaca para un viaje. Con nosotros, ¡eso ya no es un problema! Todo lo que necesita es acceso a internet.",
  "about.subtitle": "¿Para qué sirve un teléfono virtual?",
  "about.text":
    "Un número de teléfono virtual en línea le permite recibir mensajes sin importar dónde se encuentre en el mundo. Lo principal es tener acceso a la red. No necesita un teléfono móvil real para realizar todas las acciones necesarias en línea: el servicio funciona independientemente de si se encuentra en un área de cobertura móvil o no. Todo lo que necesita hacer es recargar el saldo de su número virtual. No necesita equipo especial ni tarjeta SIM.",
  "balance.payment_failed": "Hubo un error en el pago",
  "balance.payment_success": "Pago realizado con éxito",
  "common.action": "Acción",
  "common.balance": "Saldo",
  "common.cancel": "Cancelar",
  "common.confirmation.delete_body": "Confirme la acción de eliminar",
  "common.confirmation.delete_title": "¡Atención!",
  "common.email": "Email",
  "common.id": "ID",
  "common.login": "Iniciar sesión",
  "common.logout": "Cerrar sesión",
  "common.notifications.fetch_create_error": "Error al crear",
  "common.notifications.fetch_data_error": "Error al obtener datos",
  "common.password": "Contraseña",
  "common.phone": "Teléfono",
  "common.pu": "PU",
  "common.registration": "Registro",
  "common.state": "Estado",
  "common.submit": "Enviar",
  "common.username": "Nombre de usuario",
  "common.submit_form": "Enviar",
  "common.yes": "Sí",
  "common.no": "No",
  "table.adminId": "ID de administrador",
  "common.generate_api": "Generar nueva clave",
  "heading.api": "Clave API",
  "heading.api_notify":
    "Se ha enviado un correo electrónico de confirmación. El enlace es válido durante 2 horas.",
  "heading.api_text":
    "Generar una clave API para interactuar con el sitio a través del protocolo API",
  "api.new": "Nueva clave API creada exitosamente",
  "api.copy": "Copiar clave API",
  "api.modal_text":
    "Utilice esto para interactuar con el sitio a través del protocolo API",
  "api.modal_security":
    "Por razones de seguridad, esta clave API sólo se mostrará una vez.",
  "api.modal_save": "Por favor guárdalo",
  "api.error_modal":
    "Ya has solicitado una clave API para esta solicitud o ha caducado",
  "table.few": "Pocos",
  "2fa.enable": "Autenticación de dos factores",
  "2fa.notify_about_qr":
    "Se debe confirmar la autenticación para habilitarla. Ingrese el código de autenticación a continuación",
  "2fa.login": "Ingrese su código de autenticación para iniciar sesión",
  "2fa.cancel": "¿Estás seguro de que deseas cancelar 2FA?",
  "2fa.stores": "Descarga la aplicación para escanear el código QR",
  "common.your_code": "Tu código",
  "confirm.agree": "Confirme la acción",
  "confirm.cancel": "Cancelar",
  "confirm.confirm": "Confirmar",
  "country.ad": "Andorra",
  "country.ae": "Emiratos Árabes Unidos",
  "country.af": "Afganistán",
  "country.ag": "Antigua y Barbuda",
  "country.ai": "Anguila",
  "country.al": "Albania",
  "country.am": "Armenia",
  "country.an": "Antillas Neerlandesas",
  "country.ao": "Angola",
  "country.aq": "Antártida",
  "country.ar": "Argentina",
  "country.as": "Samoa Americana",
  "country.at": "Austria",
  "country.au": "Australia",
  "country.aw": "Aruba",
  "country.ax": "Islas Åland",
  "country.az": "Azerbaiyán",
  "country.ba": "Bosnia y Herzegovina",
  "country.bb": "Barbados",
  "country.bd": "Bangladés",
  "country.be": "Bélgica",
  "country.bf": "Burkina Faso",
  "country.bg": "Bulgaria",
  "country.bh": "Baréin",
  "country.bi": "Burundi",
  "country.bj": "Benín",
  "country.bm": "Bermudas",
  "country.bn": "Brunéi",
  "country.bo": "Bolivia",
  "country.br": "Brasil",
  "country.bs": "Bahamas",
  "country.bt": "Bután",
  "country.bv": "Isla Bouvet",
  "country.bw": "Botsuana",
  "country.by": "Bielorrusia",
  "country.bz": "Belice",
  "country.ca": "Canadá",
  "country.cc": "Islas Cocos",
  "country.cd": "Congo",
  "country.cf": "República Centroafricana",
  "country.cg": "Congo",
  "country.ch": "Suiza",
  "country.ci": "Costa de Marfil",
  "country.ck": "Islas Cook",
  "country.cl": "Chile",
  "country.cm": "Camerún",
  "country.cn": "China",
  "country.co": "Colombia",
  "country.cr": "Costa Rica",
  "country.cu": "Cuba",
  "country.cv": "Cabo Verde",
  "country.cx": "Isla de Navidad",
  "country.cy": "Chipre",
  "country.cz": "República Checa",
  "country.de": "Alemania",
  "country.dj": "Yibuti",
  "country.dk": "Dinamarca",
  "country.dm": "Dominica",
  "country.do": "República Dominicana",
  "country.dz": "Argelia",
  "country.ec": "Ecuador",
  "country.ee": "Estonia",
  "country.eg": "Egipto",
  "country.eh": "Sahara Occidental",
  "country.er": "Eritrea",
  "country.es": "España",
  "payout.success": "Fondos retirados exitosamente",
  "country.et": "Etiopía",
  "country.fi": "Finlandia",
  "country.fj": "Fiyi",
  "country.fk": "Islas Malvinas",
  "country.fm": "Micronesia",
  "country.fo": "Islas Feroe",
  "country.fr": "Francia",
  "country.ga": "Gabón",
  "country.gb": "Reino Unido",
  "country.gd": "Granada",
  "country.ge": "Georgia",
  "country.gf": "Guayana Francesa",
  "country.gg": "Guernsey",
  "country.gh": "Ghana",
  "country.gi": "Gibraltar",
  "country.gl": "Groenlandia",
  "country.gm": "Gambia",
  "country.gn": "Guinea",
  "country.gp": "Guadalupe",
  "country.gq": "Guinea Ecuatorial",
  "country.gr": "Grecia",
  "country.gs": "Georgia del Sur e Islas Sandwich del Sur",
  "country.gt": "Guatemala",
  "country.gu": "Guam",
  "country.gw": "Guinea-Bisáu",
  "country.gy": "Guyana",
  "country.hk": "Hong Kong",
  "country.hm": "Islas Heard y McDonald",
  "country.hn": "Honduras",
  "country.hr": "Croacia",
  "country.ht": "Haití",
  "country.hu": "Hungría",
  "country.id": "Indonesia",
  "country.ie": "Irlanda",
  "country.il": "Israel",
  "country.im": "Isla de Man",
  "country.in": "India",
  "country.io": "Territorio Británico del Océano Índico",
  "country.iq": "Irak",
  "country.ir": "Irán",
  "country.is": "Islandia",
  "country.it": "Italia",
  "country.je": "Jersey",
  "country.jm": "Jamaica",
  "country.jo": "Jordania",
  "country.jp": "Japón",
  "country.ke": "Kenia",
  "country.kg": "Kirguistán",
  "country.kh": "Camboya",
  "country.ki": "Kiribati",
  "country.km": "Comoras",
  "country.kn": "San Cristóbal y Nieves",
  "country.kp": "Corea del Norte",
  "country.kr": "Corea del Sur",
  "country.kw": "Kuwait",
  "country.ky": "Islas Caimán",
  "country.kz": "Kazajistán",
  "country.la": "Laos",
  "country.lb": "Líbano",
  "country.lc": "Santa Lucía",
  "country.li": "Liechtenstein",
  "country.lk": "Sri Lanka",
  "country.lr": "Liberia",
  "country.ls": "Lesoto",
  "country.lt": "Lituania",
  "country.lu": "Luxemburgo",
  "country.lv": "Letonia",
  "country.ly": "Libia",
  "country.ma": "Marruecos",
  "country.mc": "Mónaco",
  "country.md": "Moldavia",
  "country.me": "Montenegro",
  "country.mg": "Madagascar",
  "country.mh": "Islas Marshall",
  "country.mk": "Macedonia",
  "country.ml": "Malí",
  "country.mm": "Myanmar",
  "country.mn": "Mongolia",
  "country.mo": "Macao",
  "country.mp": "Islas Marianas del Norte",
  "country.mq": "Martinica",
  "country.mr": "Mauritania",
  "country.ms": "Montserrat",
  "country.mt": "Malta",
  "country.mu": "Mauricio",
  "country.mv": "Maldivas",
  "country.mw": "Malaui",
  "country.mx": "México",
  "country.my": "Malasia",
  "country.mz": "Mozambique",
  "country.na": "Namibia",
  "country.nc": "Nueva Caledonia",
  "country.ne": "Níger",
  "country.nf": "Isla Norfolk",
  "country.ng": "Nigeria",
  "country.ni": "Nicaragua",
  "country.nl": "Países Bajos",
  "country.no": "Noruega",
  "country.np": "Nepal",
  "country.nr": "Nauru",
  "country.nu": "Niue",
  "country.nz": "Nueva Zelanda",
  "country.om": "Omán",
  "country.pa": "Panamá",
  "country.pe": "Perú",
  "country.pf": "Polinesia Francesa",
  "country.pg": "Papúa Nueva Guinea",
  "country.ph": "Filipinas",
  "country.pk": "Pakistán",
  "country.pl": "Polonia",
  "country.pm": "San Pedro y Miquelón",
  "country.pn": "Islas Pitcairn",
  "country.pr": "Puerto Rico",
  "country.ps": "Territorios Palestinos",
  "country.pt": "Portugal",
  "country.pw": "Palaos",
  "country.py": "Paraguay",
  "country.qa": "Catar",
  "country.re": "Reunión",
  "country.ro": "Rumania",
  "country.rs": "Serbia",
  "country.ru": "Rusia",
  "country.rw": "Ruanda",
  "country.sa": "Arabia Saudita",
  "country.sb": "Islas Salomón",
  "country.sc": "Seychelles",
  "country.sd": "Sudán",
  "country.se": "Suecia",
  "country.search": "Buscar países",
  "country.sg": "Singapur",
  "country.sh": "Santa Elena",
  "country.si": "Eslovenia",
  "country.sj": "Svalbard y Jan Mayen",
  "country.sk": "Eslovaquia",
  "country.sl": "Sierra Leona",
  "country.sm": "San Marino",
  "country.sn": "Senegal",
  "country.so": "Somalia",
  "country.sr": "Surinam",
  "country.st": "Santo Tomé y Príncipe",
  "country.sv": "El Salvador",
  "country.sy": "Siria",
  "country.sz": "Esuatini",
  "country.tc": "Islas Turcas y Caicos",
  "country.td": "Chad",
  "country.tf": "Territorios Australes Franceses",
  "country.tg": "Togo",
  "country.th": "Tailandia",
  "country.tj": "Tayikistán",
  "country.tk": "Tokelau",
  "country.tl": "Timor Oriental",
  "country.tm": "Turkmenistán",
  "country.tn": "Túnez",
  "country.to": "Tonga",
  "country.tp": "Timor Oriental",
  "country.tr": "Turquía",
  "country.tt": "Trinidad y Tobago",
  "country.tv": "Tuvalu",
  "country.tw": "Taiwán",
  "country.tz": "Tanzania",
  "country.ua": "Ucrania",
  "country.ug": "Uganda",
  "country.um": "Islas menores alejadas de EE. UU.",
  "country.us": "Estados Unidos",
  "country.uy": "Uruguay",
  "country.uz": "Uzbekistán",
  "country.va": "Vaticano",
  "country.vc": "San Vicente y las Granadinas",
  "country.ve": "Venezuela",
  "country.vg": "Islas Vírgenes Británicas",
  "country.vi": "Islas Vírgenes de EE. UU.",
  "country.vn": "Vietnam",
  "country.vu": "Vanuatu",
  "country.wf": "Wallis y Futuna",
  "country.ws": "Samoa",
  "country.xy": "País aleatorio",
  "country.ye": "Yemen",
  "country.yt": "Mayotte",
  "country.za": "Sudáfrica",
  "country.zm": "Zambia",
  "country.zw": "Zimbabue",
  "filter.datepicker": "Seleccionar fecha",
  "form.update_data": "Actualizar datos",
  "front_page.body.register": "Registrarse",
  "heading.add_pay": "Recargar saldo",
  "heading.order": "Pedidos",
  "heading.payments": "Pagos",
  "heading.services": "Servicios",
  "heading.subtitle":
    "SMS-online.pro es un servicio totalmente automatizado para recibir SMS en línea. \nEsto significa que no necesita un teléfono móvil para confirmar acciones o activar cuentas en servicios populares. \nRecarga su número de cuenta y recibe el texto del mensaje SMS en la pantalla. \nNuestro sitio de activación por SMS también le ofrece alquilar un número de teléfono virtual personal.",
  "heading.tagline": "Tu servicio para recibir SMS en línea",
  "language.en": "Inglés",
  "language.gb": "Inglés",
  "language.ru": "Ruso",
  "language.es": "Español",
  "language.cn": "Chino",
  "login.subtitle": "Ingresa a tu cuenta",
  "login.title": "Iniciar sesión",
  "menu.apikey": "Tu clave API: ",
  "menu.apikey_copy": "Clave API copiada",
  "menu.history": "Historial de saldo",
  "menu.pay": "Recargar saldo",
  "menu.settings": "Configuraciones",
  "menu.sms": "Inicio",
  "modal.cancel": "Cerrar",
  "modal.create": "Crear",
  "nav.about": "Sobre nosotros",
  "nav.api": "API",
  "nav.faq": "FAQ",
  "nav.main": "Inicio",
  "nav.news": "Noticias",
  "nav.profile": "Perfil",
  "nav.services": "Servicios",
  "nav.rules": "Reglas del proyecto",
  "nav.work": "¿Cómo funciona?",
  "placeholder.description": "Descripción",
  "placeholder.email": "E-mail",
  "placeholder.image": "Imagen",
  "placeholder.is_enabled": "Activo",
  "placeholder.url": "Url",
  "placeholder.username": "Nombre",
  "panel.type": "Modo administrador",
  "common.not_valid": "No válido",
  "menu.logs": "Registros",
  "ip.ip_heading": "Lista de usuarios por dirección IP",
  "ip.email_heading": "Actividad del usuario",
  "ip.phone_heading": "Lista de usuarios de teléfonos",
  "ip.ips": "Direcciones IP",
  "ip.emails": "Correo electrónico",
  "ip.phone": "Teléfono",
  "ip.ips_from": "Direcciones IP (inicio del intervalo)",
  "ip.ips_to": "Direcciones IP (fin del intervalo)",
  "ip.get_data": "Obtener datos",
  "ip.export_csv": "Descargar CSV",
  "ip.export_excel": "Descargar Excel",
  "ip.export_json": "Descargar JSON",
  "ip.email_error": "Por favor ingresa tu correo electrónico",
  "ip.ip_error": "Por favor ingrese una dirección IP",
  "ip.phone_error": "Por favor ingresa un número de teléfono",
  "ip.interval_error": "El intervalo especificado es incorrecto",
  profile: "Perfil",
  "services.subtitle":
    "Servicios desde los cuales aceptamos SMS en este momento",
  "table.amount": "Cantidad",
  "table.approved": "Aprobado",
  "table.balance_correction": "Corrección de saldo",
  "table.correction": "Corrección de saldo",
  "table.canceled": "Cancelado",
  "table.count": "Número",
  "table.country": "País",
  "table.date": "Fecha",
  "table.dateFrom": "Fecha desde",
  "table.dateTo": "Fecha hasta",
  "table.declined": "Rechazado",
  "table.failed": "Fallido",
  "table.finished": "Terminado",
  "table.new": "Nuevo",
  "table.all": "Todo",
  "table.no_numbers": "Sin números",
  "table.notFound": "No se encontraron resultados",
  "table.not_found": "No encontrado",
  "table.order_cancel": "Pedido cancelado",
  "table.order_create": "Pedido creado con éxito",
  "table.per_page": "Por página",
  "table.price": "Precio",
  "table.refill": "Recargar saldo",
  "table.service": "Servicio",
  "table.sms_content": "SMS",
  "table.status": "Estado",
  "table.statuses": "Estados",
  "table.type": "Tipo",
  "table.waiting": "Esperando",
  "table.waiting_phone": "Esperando llamada",
  "table.waiting_sms": "Esperando mensaje",
  "text.alotof": "Mucho",
  "text.maxCount": "Cantidad máxima",
  "text.minCount": "Cantidad mínima",
  "work.subtitle":
    "Recibe mensajes de texto en un número virtual desde cualquier servicio disponible",
  "work.text1": "Registra una cuenta en nuestro sistema",
  "work.text2": "Recarga el saldo",
  "work.text3": "Recibe SMS de cualquier servicio",
  "world.africa": "África",
  "world.asia": "Asia",
  "world.choose": "Elige un país",
  "world.europe": "Europa",
  "world.north_america": "Norteamérica",
  "world.oceania": "Oceanía",
  "world.south_america": "Sudamérica",
  "rules.content":
    "<h2>Acuerdo de usuario</h2><div>1. El procedimiento para la activación es el siguiente:\n• 1.1. En el menú de la izquierda, seleccionar la red social o mensajero deseado y hacer clic en 'Comprar'\n• 1.2. Usar el número proporcionado, asegurarse de que el SMS ha sido enviado y hacer clic en el botón verde 'Listo'\n• 1.3. Esperar a que llegue el SMS y que su contenido se muestre junto al número correspondiente\n• 1.4. Si necesitas recibir más de un SMS, selecciona 'repetir' y luego envía otro mensaje desde este servicio. (En algunos números de teléfono esta función puede no estar disponible, el servicio no garantiza esta opción o puede haber un cargo adicional).\n• 1.5. Si todo es correcto y deseas terminar de trabajar con este servicio, haz clic en el botón 'Finalizar', o la activación se terminará automáticamente después de un tiempo determinado (15 minutos)\n• 1.6. El tiempo máximo de espera para la recepción de SMS es de 20 minutos, después de lo cual se finaliza la asignación del número.\n2. El costo de las activaciones se deduce según la lista de precios (mostrada en el menú en la página del usuario).\n• 2.1. El dinero se deduce del saldo al finalizar la operación (p.1.4,1.5 del reglamento).\n3. Si el número está asignado pero no se utiliza (es decir, no viste el código del SMS), puedes cancelar la operación en cualquier momento sin ninguna penalización. En caso de abuso, se aplicarán sanciones a discreción del moderador.\n4. Al registrarse en el sitio, aceptas recibir materiales publicitarios de SMS-online. Puedes darte de baja de la lista de correo en cualquier momento.\n5. El historial de operaciones con números se guarda en tu cuenta y está disponible en el menú superior 'Historial'. El historial de activaciones se guarda indefinidamente y no está sujeto a eliminación.\n6. Está prohibido utilizar SMS-online para cualquier propósito ilegal.\n• 6.1. Está prohibido utilizar el servicio para suscripciones pagadas.\n7. No nos hacemos responsables de las cuentas creadas; todas las acciones, incluidos los posibles bloqueos, se realizan exclusivamente bajo el riesgo del usuario final que adquirió la activación.\n• 7.1. Está prohibida la activación en Qiwi y Webmoney\n• 7.2. Está prohibida la activación en el sector bancario.\n8. El reembolso solo se proporciona al enviar una solicitud a <a href='mailto:support@sms-online.pro'>support@sms-online.pro</a> desde el correo electrónico con el que se realizó el registro. También te informamos que, al solicitar un reembolso por renuncia a la compra, el reembolso se realiza exclusivamente a la misma tarjeta bancaria y en la misma moneda en que se realizó el pago.\n9. La garantía para los números con reenvío es de 2 semanas. Si el número deja de funcionar por razones ajenas al control del cliente, se devolverá el dinero.\n10. No nos responsabilizamos por la programación incorrecta de la interfaz API, o por otros errores de software cometidos por el usuario al malinterpretar el protocolo API descrito. No se proporciona reembolso por errores de software de los usuarios.\n11. No está prevista la recepción de SMS del sistema de pago Qiwi.\n12. Al pagar un pedido con tarjeta bancaria, el procesamiento del pago (incluido el ingreso del número de tarjeta) se realiza en una página segura del sistema de procesamiento, que ha pasado la certificación internacional. Esto significa que tus datos confidenciales (detalles de la tarjeta, datos de registro, etc.) no llegan a la tienda en línea, su procesamiento está completamente protegido y nadie, incluido nuestro servicio, puede obtener los datos personales y bancarios del cliente. Al trabajar con datos de tarjeta, se aplica el estándar de protección de información desarrollado por los sistemas de pago internacionales Visa y Mastercard-Payment Card Industry Data Security Standard (PCI DSS), lo que garantiza el procesamiento seguro de los detalles de la tarjeta bancaria del titular. La tecnología de transmisión de datos utilizada garantiza la seguridad de las transacciones con tarjetas bancarias mediante el uso de los protocolos Secure Sockets Layer (SSL), Verified by Visa, Secure Code, y redes bancarias cerradas, que tienen el mayor grado de protección.\n13. Está prohibido explotar errores o brechas en la seguridad y será considerado por las autoridades de aplicación de la ley.\n14. La cuenta de SMS-online se identifica exclusivamente por el correo electrónico que proporcionaste durante el registro.\n15. Por razones de seguridad, la administración tiene el derecho de congelar tu cuenta en los siguientes casos: \n• 15.1. Ausencia de actividad durante 6 meses \n• 15.2. Detección de actividad sospechosa/externa.\n16. La recuperación de una cuenta congelada es posible exclusivamente a través del correo electrónico que proporcionaste durante el registro.</div>",
};
